/**
 * @generated SignedSource<<2df7bf11763cc8120ebe632f5bdcb03b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CustomContentInput = {
  attribs?: CustomContentInputAttributes | null | undefined;
  row?: number | null | undefined;
  type: string;
};
export type CustomContentInputAttributes = {
  infiniteAdsAfterNumber?: string | null | undefined;
  percentage?: string | null | undefined;
  tag?: string | null | undefined;
};
export type subSectionPageQuery$variables = {
  after?: string | null | undefined;
  articlesQueueName: string;
  commentQueueName: string;
  customContents?: ReadonlyArray<CustomContentInput | null | undefined> | null | undefined;
  entityId: string;
  first?: number | null | undefined;
  focusQueueName: string;
  hasParentSection: boolean;
  includeChinaFutureTechDiscovery: boolean;
  includeComment: boolean;
  includeFocusArticle: boolean;
  includeMultimedia: boolean;
  includePostMagazine: boolean;
  isPostMagazineSubSection: boolean;
  isSkipDefaultSubSectionQuery: boolean;
  isStyleSubSection: boolean;
  multimediaQueueName: string;
  parentSectionUuid: string;
  postMagazineSubSectionTopicQueueName: string;
  relatedSectionsQueueName: string;
  relatedTopicsQueueName: string;
  scmpPlusPaywallTypeIds?: ReadonlyArray<string | null | undefined> | null | undefined;
  sponsorQueueName: string;
};
export type subSectionPageQuery$data = {
  readonly subSection: {
    readonly " $fragmentSpreads": FragmentRefs<"contextsSectionContextProviderSection" | "hooksTrackCurrentItemBase" | "sectionSeoSection">;
  };
  readonly " $fragmentSpreads": FragmentRefs<"subSectionPostMagazineQuery" | "subSectionQuery" | "subSectionStyleContentQuery">;
};
export type subSectionPageQuery = {
  response: subSectionPageQuery$data;
  variables: subSectionPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "articlesQueueName"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "commentQueueName"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "customContents"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "entityId"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "focusQueueName"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "hasParentSection"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeChinaFutureTechDiscovery"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeComment"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeFocusArticle"
},
v11 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeMultimedia"
},
v12 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includePostMagazine"
},
v13 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isPostMagazineSubSection"
},
v14 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isSkipDefaultSubSectionQuery"
},
v15 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isStyleSubSection"
},
v16 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "multimediaQueueName"
},
v17 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "parentSectionUuid"
},
v18 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "postMagazineSubSectionTopicQueueName"
},
v19 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "relatedSectionsQueueName"
},
v20 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "relatedTopicsQueueName"
},
v21 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "scmpPlusPaywallTypeIds"
},
v22 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sponsorQueueName"
},
v23 = {
  "kind": "Variable",
  "name": "entityId",
  "variableName": "entityId"
},
v24 = [
  {
    "fields": [
      (v23/*: any*/)
    ],
    "kind": "ObjectValue",
    "name": "filter"
  }
],
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "headline",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "socialHeadline",
  "storageKey": null
},
v28 = {
  "kind": "Variable",
  "name": "customContents",
  "variableName": "customContents"
},
v29 = [
  {
    "kind": "Variable",
    "name": "bodyType",
    "variableName": "bodyType"
  },
  (v28/*: any*/)
],
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityId",
  "storageKey": null
},
v31 = [
  (v30/*: any*/)
],
v32 = {
  "args": null,
  "kind": "FragmentSpread",
  "name": "contentShareWidgetContent"
},
v33 = {
  "kind": "InlineFragment",
  "selections": (v31/*: any*/),
  "type": "Section",
  "abstractKey": null
},
v34 = {
  "kind": "InlineFragment",
  "selections": (v31/*: any*/),
  "type": "VideoSection",
  "abstractKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "concreteType": "SectionSegmentV2",
  "kind": "LinkedField",
  "name": "sectionsV2",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "value",
      "plural": true,
      "selections": [
        (v33/*: any*/),
        (v34/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v36 = [
  (v35/*: any*/)
],
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "urlAlias",
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v39 = [
  (v38/*: any*/)
],
v40 = {
  "alias": null,
  "args": null,
  "concreteType": "Topic",
  "kind": "LinkedField",
  "name": "topics",
  "plural": true,
  "selections": (v39/*: any*/),
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sentiment",
  "storageKey": null
},
v42 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityUuid",
  "storageKey": null
},
v43 = [
  (v30/*: any*/),
  (v38/*: any*/)
],
v44 = {
  "kind": "InlineFragment",
  "selections": (v43/*: any*/),
  "type": "Section",
  "abstractKey": null
},
v45 = {
  "alias": null,
  "args": null,
  "concreteType": "SectionSegmentV2",
  "kind": "LinkedField",
  "name": "sectionsV2",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "value",
      "plural": true,
      "selections": [
        (v44/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v46 = {
  "kind": "InlineFragment",
  "selections": (v39/*: any*/),
  "type": "Section",
  "abstractKey": null
},
v47 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "SectionSegmentV2",
      "kind": "LinkedField",
      "name": "sectionsV2",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "value",
          "plural": true,
          "selections": [
            (v33/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Article",
  "abstractKey": null
},
v48 = {
  "args": null,
  "kind": "FragmentSpread",
  "name": "entityLink"
},
v49 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "published",
  "storageKey": null
},
v50 = {
  "kind": "InlineFragment",
  "selections": (v39/*: any*/),
  "type": "VideoSection",
  "abstractKey": null
},
v51 = [
  {
    "defaultValue": "PARAGRAPH",
    "kind": "LocalArgument",
    "name": "bodyType"
  },
  {
    "defaultValue": ([]/*: any*/),
    "kind": "LocalArgument",
    "name": "customContents"
  }
],
v52 = [
  (v32/*: any*/)
],
v53 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Section",
      "kind": "LinkedField",
      "name": "fullSectionPath",
      "plural": true,
      "selections": (v31/*: any*/),
      "storageKey": null
    }
  ],
  "type": "Section",
  "abstractKey": null
},
v54 = {
  "kind": "Variable",
  "name": "after",
  "variableName": "after"
},
v55 = {
  "kind": "Variable",
  "name": "articlesQueueName",
  "variableName": "articlesQueueName"
},
v56 = {
  "kind": "Variable",
  "name": "first",
  "variableName": "first"
},
v57 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "version",
      "value": 2
    }
  ],
  "kind": "ScalarField",
  "name": "advertZone",
  "storageKey": "advertZone(version:2)"
},
v58 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "text",
  "storageKey": null
},
v59 = [
  (v58/*: any*/)
],
v60 = {
  "alias": null,
  "args": null,
  "concreteType": "FormattedValue",
  "kind": "LinkedField",
  "name": "description",
  "plural": false,
  "selections": (v59/*: any*/),
  "storageKey": null
},
v61 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v62 = [
  (v61/*: any*/)
],
v63 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "parentSection",
  "storageKey": null
},
v64 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v65 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "shortUrl",
  "storageKey": null
},
v66 = {
  "kind": "InlineFragment",
  "selections": [
    (v64/*: any*/)
  ],
  "type": "Node",
  "abstractKey": "__isNode"
},
v67 = [
  (v38/*: any*/),
  (v64/*: any*/)
],
v68 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "publishedDate",
  "storageKey": null
},
v69 = {
  "alias": null,
  "args": null,
  "concreteType": "UrlRedirect",
  "kind": "LinkedField",
  "name": "urlRedirect",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "toUrl",
      "storageKey": null
    },
    (v64/*: any*/)
  ],
  "storageKey": null
},
v70 = [
  (v30/*: any*/),
  (v64/*: any*/)
],
v71 = {
  "alias": null,
  "args": null,
  "concreteType": "Application",
  "kind": "LinkedField",
  "name": "application",
  "plural": false,
  "selections": (v70/*: any*/),
  "storageKey": null
},
v72 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Section",
      "kind": "LinkedField",
      "name": "fullSectionPath",
      "plural": true,
      "selections": (v70/*: any*/),
      "storageKey": null
    },
    (v63/*: any*/)
  ],
  "type": "Section",
  "abstractKey": null
},
v73 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "flattenTypeIds",
  "storageKey": null
},
v74 = {
  "alias": null,
  "args": null,
  "concreteType": "LiveArticle",
  "kind": "LinkedField",
  "name": "liveArticle",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    (v64/*: any*/)
  ],
  "storageKey": null
},
v75 = {
  "kind": "InlineFragment",
  "selections": [
    (v73/*: any*/),
    (v74/*: any*/)
  ],
  "type": "Article",
  "abstractKey": null
},
v76 = {
  "alias": null,
  "args": null,
  "concreteType": "PaywallType",
  "kind": "LinkedField",
  "name": "paywallTypes",
  "plural": true,
  "selections": [
    (v42/*: any*/),
    (v64/*: any*/)
  ],
  "storageKey": null
},
v77 = {
  "kind": "InlineFragment",
  "selections": [
    (v76/*: any*/)
  ],
  "type": "Article",
  "abstractKey": null
},
v78 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "SectionSegmentV2",
      "kind": "LinkedField",
      "name": "sectionsV2",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "value",
          "plural": true,
          "selections": [
            (v25/*: any*/),
            (v33/*: any*/),
            (v66/*: any*/),
            (v34/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v77/*: any*/)
  ],
  "type": "Content",
  "abstractKey": "__isContent"
},
v79 = {
  "kind": "InlineFragment",
  "selections": [
    (v42/*: any*/),
    (v37/*: any*/),
    (v69/*: any*/),
    (v71/*: any*/),
    (v72/*: any*/),
    (v75/*: any*/),
    (v78/*: any*/)
  ],
  "type": "BaseWithApplicationAndUrlAlias",
  "abstractKey": "__isBaseWithApplicationAndUrlAlias"
},
v80 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sponsorType",
  "storageKey": null
},
v81 = {
  "kind": "InlineFragment",
  "selections": [
    (v25/*: any*/),
    (v42/*: any*/),
    (v37/*: any*/),
    (v69/*: any*/),
    (v71/*: any*/),
    (v72/*: any*/),
    (v75/*: any*/),
    (v78/*: any*/)
  ],
  "type": "BaseWithApplicationAndUrlAlias",
  "abstractKey": "__isBaseWithApplicationAndUrlAlias"
},
v82 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v83 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "style": "768x768"
    }
  }
],
v84 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedDate",
  "storageKey": null
},
v85 = {
  "alias": null,
  "args": null,
  "concreteType": "FormattedValue",
  "kind": "LinkedField",
  "name": "summary",
  "plural": false,
  "selections": (v59/*: any*/),
  "storageKey": null
},
v86 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "readingTime",
  "storageKey": null
},
v87 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "commentCount",
  "storageKey": null
},
v88 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "flag",
  "storageKey": null
},
v89 = {
  "alias": null,
  "args": null,
  "concreteType": "Sponsor",
  "kind": "LinkedField",
  "name": "sponsor",
  "plural": false,
  "selections": [
    (v38/*: any*/),
    (v82/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Image",
      "kind": "LinkedField",
      "name": "images",
      "plural": true,
      "selections": (v62/*: any*/),
      "storageKey": null
    },
    (v64/*: any*/)
  ],
  "storageKey": null
},
v90 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "types",
  "storageKey": null
},
v91 = {
  "alias": null,
  "args": null,
  "concreteType": "Author",
  "kind": "LinkedField",
  "name": "authors",
  "plural": true,
  "selections": [
    (v90/*: any*/)
  ],
  "storageKey": null
},
v92 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "youtubeId",
  "storageKey": null
},
v93 = {
  "kind": "InlineFragment",
  "selections": [
    (v92/*: any*/)
  ],
  "type": "Video",
  "abstractKey": null
},
v94 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "type": "TERM_LOGO"
    }
  }
],
v95 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "filter",
        "value": {
          "style": "100x100"
        }
      }
    ],
    "concreteType": "ImageStyle",
    "kind": "LinkedField",
    "name": "style",
    "plural": false,
    "selections": (v62/*: any*/),
    "storageKey": "style(filter:{\"style\":\"100x100\"})"
  }
],
v96 = {
  "alias": "sectionLogo",
  "args": (v94/*: any*/),
  "concreteType": "Image",
  "kind": "LinkedField",
  "name": "image",
  "plural": false,
  "selections": (v95/*: any*/),
  "storageKey": "image(filter:{\"type\":\"TERM_LOGO\"})"
},
v97 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "json",
  "storageKey": null
},
v98 = [
  (v97/*: any*/)
],
v99 = {
  "kind": "InlineFragment",
  "selections": [
    (v38/*: any*/),
    (v37/*: any*/)
  ],
  "type": "Topic",
  "abstractKey": null
},
v100 = [
  (v38/*: any*/),
  (v37/*: any*/),
  (v69/*: any*/)
],
v101 = {
  "kind": "InlineFragment",
  "selections": (v100/*: any*/),
  "type": "Section",
  "abstractKey": null
},
v102 = {
  "kind": "InlineFragment",
  "selections": [
    (v30/*: any*/),
    (v42/*: any*/),
    (v37/*: any*/),
    (v69/*: any*/),
    (v71/*: any*/),
    (v72/*: any*/),
    (v75/*: any*/),
    (v78/*: any*/)
  ],
  "type": "BaseWithApplicationAndUrlAlias",
  "abstractKey": "__isBaseWithApplicationAndUrlAlias"
},
v103 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "name",
        "variableName": "articlesQueueName"
      }
    ],
    "kind": "ObjectValue",
    "name": "filter"
  }
],
v104 = [
  (v54/*: any*/),
  (v56/*: any*/)
],
v105 = {
  "alias": null,
  "args": null,
  "concreteType": "Newsletter",
  "kind": "LinkedField",
  "name": "relatedNewsletters",
  "plural": true,
  "selections": [
    (v30/*: any*/),
    (v38/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "alternativeName",
      "storageKey": null
    },
    (v60/*: any*/),
    (v85/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "FormattedValue",
      "kind": "LinkedField",
      "name": "homepageDescription",
      "plural": false,
      "selections": (v59/*: any*/),
      "storageKey": null
    },
    (v64/*: any*/)
  ],
  "storageKey": null
},
v106 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "shortName",
  "storageKey": null
},
v107 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "disableFollow",
  "storageKey": null
},
v108 = [
  (v107/*: any*/)
],
v109 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdDate",
  "storageKey": null
},
v110 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v111 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "style": "1200x800"
    }
  }
],
v112 = {
  "alias": "size1200x800",
  "args": (v111/*: any*/),
  "concreteType": "ImageStyle",
  "kind": "LinkedField",
  "name": "style",
  "plural": false,
  "selections": (v62/*: any*/),
  "storageKey": "style(filter:{\"style\":\"1200x800\"})"
},
v113 = {
  "alias": "size540x360",
  "args": [
    {
      "kind": "Literal",
      "name": "filter",
      "value": {
        "style": "540x360"
      }
    }
  ],
  "concreteType": "ImageStyle",
  "kind": "LinkedField",
  "name": "style",
  "plural": false,
  "selections": (v62/*: any*/),
  "storageKey": "style(filter:{\"style\":\"540x360\"})"
},
v114 = {
  "alias": "landscape250x99",
  "args": [
    {
      "kind": "Literal",
      "name": "filter",
      "value": {
        "style": "landscape_250_99"
      }
    }
  ],
  "concreteType": "ImageStyle",
  "kind": "LinkedField",
  "name": "style",
  "plural": false,
  "selections": (v62/*: any*/),
  "storageKey": "style(filter:{\"style\":\"landscape_250_99\"})"
},
v115 = {
  "alias": null,
  "args": null,
  "concreteType": "SectionSegmentV2",
  "kind": "LinkedField",
  "name": "sectionsV2",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "value",
      "plural": true,
      "selections": [
        (v25/*: any*/),
        {
          "kind": "TypeDiscriminator",
          "abstractKey": "__isSectionUnion"
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v38/*: any*/),
            (v105/*: any*/)
          ],
          "type": "Section",
          "abstractKey": null
        },
        (v50/*: any*/),
        (v66/*: any*/),
        (v102/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v116 = {
  "alias": null,
  "args": null,
  "concreteType": "FormattedValue",
  "kind": "LinkedField",
  "name": "subHeadline",
  "plural": false,
  "selections": (v98/*: any*/),
  "storageKey": null
},
v117 = {
  "alias": null,
  "args": null,
  "concreteType": "FormattedValue",
  "kind": "LinkedField",
  "name": "summary",
  "plural": false,
  "selections": [
    (v97/*: any*/),
    (v58/*: any*/)
  ],
  "storageKey": null
},
v118 = {
  "kind": "InlineFragment",
  "selections": [
    (v35/*: any*/),
    (v77/*: any*/)
  ],
  "type": "Content",
  "abstractKey": "__isContent"
},
v119 = {
  "kind": "InlineFragment",
  "selections": [
    (v42/*: any*/),
    (v69/*: any*/),
    (v71/*: any*/),
    (v72/*: any*/),
    (v75/*: any*/),
    (v118/*: any*/)
  ],
  "type": "BaseWithApplicationAndUrlAlias",
  "abstractKey": "__isBaseWithApplicationAndUrlAlias"
},
v120 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "seriesShortLabel",
  "storageKey": null
},
v121 = {
  "kind": "InlineFragment",
  "selections": [
    (v25/*: any*/),
    (v30/*: any*/),
    (v42/*: any*/),
    (v37/*: any*/),
    (v69/*: any*/),
    (v71/*: any*/),
    (v72/*: any*/),
    (v75/*: any*/),
    (v78/*: any*/)
  ],
  "type": "BaseWithApplicationAndUrlAlias",
  "abstractKey": "__isBaseWithApplicationAndUrlAlias"
},
v122 = {
  "alias": null,
  "args": null,
  "concreteType": "Article",
  "kind": "LinkedField",
  "name": "seriesContainer",
  "plural": false,
  "selections": [
    (v120/*: any*/),
    (v64/*: any*/),
    (v121/*: any*/)
  ],
  "storageKey": null
},
v123 = {
  "alias": null,
  "args": null,
  "concreteType": "FormattedValue",
  "kind": "LinkedField",
  "name": "multimediaEmbed",
  "plural": false,
  "selections": (v98/*: any*/),
  "storageKey": null
},
v124 = {
  "alias": null,
  "args": null,
  "concreteType": "ArticleTypeSegment",
  "kind": "LinkedField",
  "name": "types",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ArticleType",
      "kind": "LinkedField",
      "name": "value",
      "plural": true,
      "selections": [
        (v30/*: any*/),
        (v64/*: any*/),
        (v38/*: any*/),
        (v60/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v125 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasVideoContent",
  "storageKey": null
},
v126 = {
  "alias": null,
  "args": null,
  "concreteType": "Author",
  "kind": "LinkedField",
  "name": "authors",
  "plural": true,
  "selections": [
    (v90/*: any*/),
    (v64/*: any*/),
    (v30/*: any*/)
  ],
  "storageKey": null
},
v127 = {
  "kind": "InlineFragment",
  "selections": (v36/*: any*/),
  "type": "Content",
  "abstractKey": "__isContent"
},
v128 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "duration",
  "storageKey": null
},
v129 = {
  "alias": null,
  "args": null,
  "concreteType": "SectionSegmentV2",
  "kind": "LinkedField",
  "name": "sectionsV2",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "value",
      "plural": true,
      "selections": [
        (v34/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v130 = {
  "kind": "InlineFragment",
  "selections": [
    (v92/*: any*/),
    (v128/*: any*/),
    (v129/*: any*/)
  ],
  "type": "Video",
  "abstractKey": null
},
v131 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v132 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v133 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "entityUuid",
        "variableName": "parentSectionUuid"
      }
    ],
    "kind": "ObjectValue",
    "name": "filter"
  }
],
v134 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 5
  }
],
v135 = {
  "alias": "size768x768",
  "args": (v83/*: any*/),
  "concreteType": "ImageStyle",
  "kind": "LinkedField",
  "name": "style",
  "plural": false,
  "selections": (v62/*: any*/),
  "storageKey": "style(filter:{\"style\":\"768x768\"})"
},
v136 = {
  "alias": null,
  "args": null,
  "concreteType": "Image",
  "kind": "LinkedField",
  "name": "images",
  "plural": true,
  "selections": [
    (v61/*: any*/),
    (v110/*: any*/),
    (v82/*: any*/),
    (v135/*: any*/),
    (v113/*: any*/)
  ],
  "storageKey": null
},
v137 = {
  "alias": null,
  "args": null,
  "concreteType": "SectionSegmentV2",
  "kind": "LinkedField",
  "name": "sectionsV2",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "value",
      "plural": true,
      "selections": [
        (v25/*: any*/),
        (v46/*: any*/),
        (v50/*: any*/),
        (v66/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v138 = {
  "alias": null,
  "args": null,
  "concreteType": "Topic",
  "kind": "LinkedField",
  "name": "topics",
  "plural": true,
  "selections": [
    (v30/*: any*/),
    (v89/*: any*/),
    (v64/*: any*/)
  ],
  "storageKey": null
},
v139 = {
  "kind": "InlineFragment",
  "selections": [
    (v42/*: any*/),
    (v37/*: any*/),
    (v69/*: any*/),
    (v71/*: any*/),
    (v72/*: any*/),
    (v75/*: any*/),
    (v118/*: any*/)
  ],
  "type": "BaseWithApplicationAndUrlAlias",
  "abstractKey": "__isBaseWithApplicationAndUrlAlias"
},
v140 = {
  "kind": "InlineFragment",
  "selections": [
    (v87/*: any*/),
    (v123/*: any*/),
    (v124/*: any*/),
    (v125/*: any*/),
    (v126/*: any*/),
    (v80/*: any*/),
    (v127/*: any*/)
  ],
  "type": "Article",
  "abstractKey": null
},
v141 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1
  }
],
v142 = [
  (v64/*: any*/),
  (v121/*: any*/)
],
v143 = {
  "kind": "Literal",
  "name": "first",
  "value": 6
},
v144 = {
  "kind": "InlineFragment",
  "selections": [
    (v25/*: any*/),
    (v42/*: any*/),
    (v69/*: any*/),
    (v71/*: any*/),
    (v72/*: any*/),
    (v75/*: any*/),
    (v78/*: any*/)
  ],
  "type": "BaseWithApplicationAndUrlAlias",
  "abstractKey": "__isBaseWithApplicationAndUrlAlias"
},
v145 = {
  "alias": null,
  "args": null,
  "concreteType": "Image",
  "kind": "LinkedField",
  "name": "images",
  "plural": true,
  "selections": [
    (v61/*: any*/),
    (v110/*: any*/),
    (v82/*: any*/),
    (v112/*: any*/),
    (v113/*: any*/)
  ],
  "storageKey": null
},
v146 = {
  "kind": "InlineFragment",
  "selections": [
    (v30/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        (v37/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "Topic",
          "kind": "LinkedField",
          "name": "topics",
          "plural": true,
          "selections": [
            (v30/*: any*/),
            (v89/*: any*/),
            (v64/*: any*/),
            (v105/*: any*/),
            (v37/*: any*/),
            (v38/*: any*/),
            (v106/*: any*/),
            (v144/*: any*/)
          ],
          "storageKey": null
        },
        (v109/*: any*/),
        (v84/*: any*/),
        (v68/*: any*/),
        (v86/*: any*/),
        (v26/*: any*/),
        (v145/*: any*/),
        (v27/*: any*/),
        (v88/*: any*/),
        (v115/*: any*/),
        (v116/*: any*/),
        (v117/*: any*/),
        (v65/*: any*/),
        (v119/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            (v76/*: any*/),
            (v73/*: any*/),
            (v74/*: any*/),
            (v120/*: any*/),
            (v122/*: any*/),
            (v80/*: any*/),
            (v87/*: any*/),
            (v123/*: any*/),
            (v124/*: any*/),
            (v125/*: any*/),
            (v126/*: any*/),
            (v105/*: any*/),
            (v127/*: any*/)
          ],
          "type": "Article",
          "abstractKey": null
        },
        (v130/*: any*/)
      ],
      "type": "Content",
      "abstractKey": "__isContent"
    }
  ],
  "type": "Article",
  "abstractKey": null
},
v147 = [
  (v38/*: any*/),
  (v107/*: any*/)
],
v148 = [
  (v143/*: any*/)
],
v149 = {
  "alias": null,
  "args": null,
  "concreteType": "ArticleTypeSegment",
  "kind": "LinkedField",
  "name": "types",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ArticleType",
      "kind": "LinkedField",
      "name": "value",
      "plural": true,
      "selections": [
        (v38/*: any*/),
        (v30/*: any*/),
        (v60/*: any*/),
        (v64/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v150 = {
  "kind": "InlineFragment",
  "selections": [
    (v42/*: any*/),
    (v69/*: any*/),
    (v71/*: any*/),
    (v72/*: any*/),
    (v118/*: any*/)
  ],
  "type": "BaseWithApplicationAndUrlAlias",
  "abstractKey": "__isBaseWithApplicationAndUrlAlias"
},
v151 = {
  "kind": "InlineFragment",
  "selections": [
    (v87/*: any*/),
    (v73/*: any*/),
    (v74/*: any*/),
    (v80/*: any*/),
    (v149/*: any*/),
    (v126/*: any*/),
    (v150/*: any*/),
    (v127/*: any*/)
  ],
  "type": "Article",
  "abstractKey": null
},
v152 = {
  "kind": "InlineFragment",
  "selections": [
    (v128/*: any*/),
    (v129/*: any*/)
  ],
  "type": "Video",
  "abstractKey": null
},
v153 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "entityId": "71"
    }
  }
],
v154 = {
  "alias": null,
  "args": null,
  "concreteType": "Image",
  "kind": "LinkedField",
  "name": "images",
  "plural": true,
  "selections": (v95/*: any*/),
  "storageKey": null
},
v155 = {
  "kind": "InlineFragment",
  "selections": [
    (v149/*: any*/),
    (v126/*: any*/),
    (v80/*: any*/),
    (v127/*: any*/)
  ],
  "type": "Article",
  "abstractKey": null
},
v156 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "filter",
      "value": {
        "type": {
          "values": [
            "logo"
          ]
        }
      }
    }
  ],
  "concreteType": "Image",
  "kind": "LinkedField",
  "name": "images",
  "plural": true,
  "selections": (v62/*: any*/),
  "storageKey": "images(filter:{\"type\":{\"values\":[\"logo\"]}})"
},
v157 = {
  "alias": null,
  "args": null,
  "concreteType": "Topic",
  "kind": "LinkedField",
  "name": "topics",
  "plural": true,
  "selections": [
    (v30/*: any*/),
    (v89/*: any*/),
    (v64/*: any*/),
    (v37/*: any*/),
    (v38/*: any*/),
    (v106/*: any*/),
    (v144/*: any*/)
  ],
  "storageKey": null
},
v158 = {
  "kind": "InlineFragment",
  "selections": [
    (v80/*: any*/),
    (v149/*: any*/),
    (v126/*: any*/),
    (v127/*: any*/)
  ],
  "type": "Article",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/),
      (v15/*: any*/),
      (v16/*: any*/),
      (v17/*: any*/),
      (v18/*: any*/),
      (v19/*: any*/),
      (v20/*: any*/),
      (v21/*: any*/),
      (v22/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "subSectionPageQuery",
    "selections": [
      {
        "alias": "subSection",
        "args": (v24/*: any*/),
        "concreteType": "Section",
        "kind": "LinkedField",
        "name": "section",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "contextsSectionContextProviderSection"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "sectionSeoSection"
          },
          {
            "kind": "InlineDataFragmentSpread",
            "name": "hooksTrackCurrentItemBase",
            "selections": [
              {
                "kind": "InlineFragment",
                "selections": [
                  (v25/*: any*/),
                  {
                    "kind": "InlineDataFragmentSpread",
                    "name": "atomsCurrentArticleAtomBase",
                    "selections": [
                      (v25/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "kind": "InlineDataFragmentSpread",
                            "name": "articleHeadlineHeaderFeaturesContent",
                            "selections": [
                              (v26/*: any*/),
                              (v27/*: any*/)
                            ],
                            "args": null,
                            "argumentDefinitions": []
                          },
                          {
                            "args": (v29/*: any*/),
                            "kind": "FragmentSpread",
                            "name": "articleSeoArticle"
                          },
                          {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "articleShareWidgetArticle"
                          },
                          {
                            "kind": "InlineDataFragmentSpread",
                            "name": "bookmarkHeaderFeaturesContent",
                            "selections": (v31/*: any*/),
                            "args": null,
                            "argumentDefinitions": []
                          },
                          {
                            "kind": "InlineDataFragmentSpread",
                            "name": "commentHeaderFeaturesArticle",
                            "selections": [
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "args": null,
                                    "kind": "FragmentSpread",
                                    "name": "articleCommentsTriggerArticle"
                                  }
                                ],
                                "type": "Article",
                                "abstractKey": null
                              }
                            ],
                            "args": null,
                            "argumentDefinitions": []
                          },
                          (v32/*: any*/),
                          {
                            "kind": "InlineDataFragmentSpread",
                            "name": "helpersCheckIsStyleArticle",
                            "selections": (v36/*: any*/),
                            "args": null,
                            "argumentDefinitions": []
                          },
                          {
                            "kind": "InlineDataFragmentSpread",
                            "name": "helpersUseSharingUrl",
                            "selections": [
                              (v37/*: any*/)
                            ],
                            "args": null,
                            "argumentDefinitions": []
                          },
                          {
                            "kind": "InlineDataFragmentSpread",
                            "name": "hooksContentInterestArticle",
                            "selections": [
                              (v25/*: any*/),
                              (v30/*: any*/),
                              (v37/*: any*/),
                              (v40/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v41/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ArticleTypeSegment",
                                    "kind": "LinkedField",
                                    "name": "types",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ArticleType",
                                        "kind": "LinkedField",
                                        "name": "value",
                                        "plural": true,
                                        "selections": (v39/*: any*/),
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "type": "Article",
                                "abstractKey": null
                              }
                            ],
                            "args": null,
                            "argumentDefinitions": []
                          },
                          {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "hooksTrackPageViewArticle"
                          },
                          {
                            "kind": "InlineDataFragmentSpread",
                            "name": "hooksUseCurrentArticleIdsArticle",
                            "selections": [
                              (v30/*: any*/),
                              (v42/*: any*/)
                            ],
                            "args": null,
                            "argumentDefinitions": []
                          },
                          {
                            "kind": "InlineDataFragmentSpread",
                            "name": "hooksUseCurrentArticlePrebidConfigArticle",
                            "selections": [
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v45/*: any*/),
                                  (v40/*: any*/)
                                ],
                                "type": "Article",
                                "abstractKey": null
                              }
                            ],
                            "args": null,
                            "argumentDefinitions": []
                          },
                          {
                            "kind": "InlineDataFragmentSpread",
                            "name": "hooksUsePageTargetingArticle",
                            "selections": [
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "SectionSegmentV2",
                                    "kind": "LinkedField",
                                    "name": "sectionsV2",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": null,
                                        "kind": "LinkedField",
                                        "name": "value",
                                        "plural": true,
                                        "selections": [
                                          (v46/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Topic",
                                    "kind": "LinkedField",
                                    "name": "firstTopic",
                                    "plural": false,
                                    "selections": (v39/*: any*/),
                                    "storageKey": null
                                  }
                                ],
                                "type": "Article",
                                "abstractKey": null
                              }
                            ],
                            "args": null,
                            "argumentDefinitions": []
                          },
                          {
                            "kind": "InlineDataFragmentSpread",
                            "name": "onboardingNewsletterSubscriptionArticle",
                            "selections": [
                              (v47/*: any*/)
                            ],
                            "args": null,
                            "argumentDefinitions": []
                          },
                          {
                            "kind": "InlineDataFragmentSpread",
                            "name": "entityLinkHeaderFeaturesArticle",
                            "selections": [
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Author",
                                    "kind": "LinkedField",
                                    "name": "authors",
                                    "plural": true,
                                    "selections": [
                                      (v38/*: any*/),
                                      (v48/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "SectionSegmentV2",
                                    "kind": "LinkedField",
                                    "name": "sectionsV2",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": null,
                                        "kind": "LinkedField",
                                        "name": "value",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v38/*: any*/),
                                              (v49/*: any*/),
                                              (v48/*: any*/)
                                            ],
                                            "type": "Section",
                                            "abstractKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "type": "Article",
                                "abstractKey": null
                              }
                            ],
                            "args": null,
                            "argumentDefinitions": []
                          },
                          {
                            "kind": "InlineDataFragmentSpread",
                            "name": "shareHeaderFeaturesContent",
                            "selections": [
                              {
                                "args": null,
                                "kind": "FragmentSpread",
                                "name": "shareArticle20Content"
                              }
                            ],
                            "args": null,
                            "argumentDefinitions": []
                          },
                          {
                            "kind": "InlineDataFragmentSpread",
                            "name": "helpersRosettaArticleContextArticle",
                            "selections": [
                              (v40/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "SectionSegmentV2",
                                "kind": "LinkedField",
                                "name": "sectionsV2",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "value",
                                    "plural": true,
                                    "selections": [
                                      (v46/*: any*/),
                                      (v50/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "args": null,
                            "argumentDefinitions": []
                          }
                        ],
                        "type": "Content",
                        "abstractKey": "__isContent"
                      }
                    ],
                    "args": (v29/*: any*/),
                    "argumentDefinitions": (v51/*: any*/)
                  },
                  {
                    "kind": "InlineDataFragmentSpread",
                    "name": "atomsCurrentShareContentAtomBase",
                    "selections": [
                      (v25/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": (v52/*: any*/),
                        "type": "Article",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v52/*: any*/),
                        "type": "Video",
                        "abstractKey": null
                      }
                    ],
                    "args": null,
                    "argumentDefinitions": []
                  },
                  {
                    "kind": "InlineDataFragmentSpread",
                    "name": "atomsCurrentStyleCardCarouselWidgetSectionsAtomBase",
                    "selections": [
                      (v25/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v45/*: any*/)
                        ],
                        "type": "Article",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Section",
                            "kind": "LinkedField",
                            "name": "fullSectionPath",
                            "plural": true,
                            "selections": (v43/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "type": "Section",
                        "abstractKey": null
                      }
                    ],
                    "args": null,
                    "argumentDefinitions": []
                  },
                  {
                    "kind": "InlineDataFragmentSpread",
                    "name": "atomsCurrentTakeoverAdSectionsAtomBase",
                    "selections": [
                      (v25/*: any*/),
                      (v47/*: any*/),
                      (v53/*: any*/)
                    ],
                    "args": null,
                    "argumentDefinitions": []
                  }
                ],
                "type": "BaseWithApplicationAndUrlAlias",
                "abstractKey": "__isBaseWithApplicationAndUrlAlias"
              }
            ],
            "args": [
              (v28/*: any*/)
            ],
            "argumentDefinitions": (v51/*: any*/)
          }
        ],
        "storageKey": null
      },
      {
        "condition": "isSkipDefaultSubSectionQuery",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "args": [
              (v54/*: any*/),
              (v55/*: any*/),
              {
                "kind": "Variable",
                "name": "commentQueueName",
                "variableName": "commentQueueName"
              },
              (v23/*: any*/),
              (v56/*: any*/),
              {
                "kind": "Variable",
                "name": "focusQueueName",
                "variableName": "focusQueueName"
              },
              {
                "kind": "Variable",
                "name": "hasParentSection",
                "variableName": "hasParentSection"
              },
              {
                "kind": "Variable",
                "name": "includeChinaFutureTechDiscovery",
                "variableName": "includeChinaFutureTechDiscovery"
              },
              {
                "kind": "Variable",
                "name": "includeComment",
                "variableName": "includeComment"
              },
              {
                "kind": "Variable",
                "name": "includeFocusArticle",
                "variableName": "includeFocusArticle"
              },
              {
                "kind": "Variable",
                "name": "includeMultimedia",
                "variableName": "includeMultimedia"
              },
              {
                "kind": "Variable",
                "name": "includePostMagazine",
                "variableName": "includePostMagazine"
              },
              {
                "kind": "Variable",
                "name": "multimediaQueueName",
                "variableName": "multimediaQueueName"
              },
              {
                "kind": "Variable",
                "name": "parentSectionUuid",
                "variableName": "parentSectionUuid"
              },
              {
                "kind": "Variable",
                "name": "relatedTopicsQueueName",
                "variableName": "relatedTopicsQueueName"
              },
              {
                "kind": "Variable",
                "name": "scmpPlusPaywallTypeIds",
                "variableName": "scmpPlusPaywallTypeIds"
              }
            ],
            "kind": "FragmentSpread",
            "name": "subSectionQuery"
          }
        ]
      },
      {
        "condition": "isStyleSubSection",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": [
              (v54/*: any*/),
              (v55/*: any*/),
              (v23/*: any*/),
              (v56/*: any*/),
              {
                "kind": "Variable",
                "name": "relatedSectionsQueueName",
                "variableName": "relatedSectionsQueueName"
              }
            ],
            "kind": "FragmentSpread",
            "name": "subSectionStyleContentQuery"
          }
        ]
      },
      {
        "condition": "isPostMagazineSubSection",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": [
              (v54/*: any*/),
              (v55/*: any*/),
              (v23/*: any*/),
              (v56/*: any*/),
              {
                "kind": "Variable",
                "name": "postMagazineSubSectionTopicQueueName",
                "variableName": "postMagazineSubSectionTopicQueueName"
              },
              {
                "kind": "Variable",
                "name": "sponsorQueueName",
                "variableName": "sponsorQueueName"
              }
            ],
            "kind": "FragmentSpread",
            "name": "subSectionPostMagazineQuery"
          }
        ]
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v15/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/),
      (v16/*: any*/),
      (v19/*: any*/),
      (v21/*: any*/),
      (v17/*: any*/),
      (v20/*: any*/),
      (v18/*: any*/),
      (v7/*: any*/),
      (v22/*: any*/),
      (v9/*: any*/),
      (v8/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/)
    ],
    "kind": "Operation",
    "name": "subSectionPageQuery",
    "selections": [
      {
        "alias": "subSection",
        "args": (v24/*: any*/),
        "concreteType": "Section",
        "kind": "LinkedField",
        "name": "section",
        "plural": false,
        "selections": [
          (v57/*: any*/),
          (v30/*: any*/),
          (v38/*: any*/),
          (v60/*: any*/),
          (v42/*: any*/),
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "filter",
                "value": {
                  "type": "OG"
                }
              }
            ],
            "concreteType": "Image",
            "kind": "LinkedField",
            "name": "image",
            "plural": false,
            "selections": (v62/*: any*/),
            "storageKey": "image(filter:{\"type\":\"OG\"})"
          },
          (v63/*: any*/),
          (v37/*: any*/),
          (v64/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v25/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v26/*: any*/),
                  (v27/*: any*/),
                  (v65/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SectionSegmentV2",
                    "kind": "LinkedField",
                    "name": "sectionsV2",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "value",
                        "plural": true,
                        "selections": [
                          (v25/*: any*/),
                          (v44/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": (v43/*: any*/),
                            "type": "VideoSection",
                            "abstractKey": null
                          },
                          (v66/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Topic",
                    "kind": "LinkedField",
                    "name": "topics",
                    "plural": true,
                    "selections": (v67/*: any*/),
                    "storageKey": null
                  },
                  (v68/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Author",
                    "kind": "LinkedField",
                    "name": "authors",
                    "plural": true,
                    "selections": (v67/*: any*/),
                    "storageKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ArticleTypeSegment",
                        "kind": "LinkedField",
                        "name": "types",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ArticleType",
                            "kind": "LinkedField",
                            "name": "value",
                            "plural": true,
                            "selections": [
                              (v30/*: any*/),
                              (v64/*: any*/),
                              (v38/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "SectionSegmentV2",
                        "kind": "LinkedField",
                        "name": "sectionsV2",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "value",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v49/*: any*/),
                                  (v79/*: any*/)
                                ],
                                "type": "Section",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "disableOffPlatformContent",
                        "storageKey": null
                      },
                      (v80/*: any*/),
                      (v49/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Author",
                        "kind": "LinkedField",
                        "name": "authors",
                        "plural": true,
                        "selections": [
                          (v30/*: any*/),
                          (v81/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Image",
                        "kind": "LinkedField",
                        "name": "images",
                        "plural": true,
                        "selections": [
                          {
                            "alias": "generic_og",
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "filter",
                                "value": {
                                  "style": "og_image_scmp_generic"
                                }
                              }
                            ],
                            "concreteType": "ImageStyle",
                            "kind": "LinkedField",
                            "name": "style",
                            "plural": false,
                            "selections": (v62/*: any*/),
                            "storageKey": "style(filter:{\"style\":\"og_image_scmp_generic\"})"
                          },
                          {
                            "alias": null,
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "filter",
                                "value": {
                                  "styles": [
                                    "og_postmag",
                                    "og_image_style",
                                    "og_image_scmp_analysis",
                                    "og_image_scmp_explainer",
                                    "og_image_scmp_editorial",
                                    "og_image_scmp_fact_check",
                                    "og_image_scmp_live",
                                    "og_image_scmp_obituary",
                                    "og_image_scmp_opinion",
                                    "og_image_scmp_review",
                                    "og_image_scmp_series",
                                    "og_image_scmp_generic"
                                  ]
                                }
                              }
                            ],
                            "concreteType": "ImageStyle",
                            "kind": "LinkedField",
                            "name": "styles",
                            "plural": true,
                            "selections": [
                              (v61/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "style",
                                "storageKey": null
                              }
                            ],
                            "storageKey": "styles(filter:{\"styles\":[\"og_postmag\",\"og_image_style\",\"og_image_scmp_analysis\",\"og_image_scmp_explainer\",\"og_image_scmp_editorial\",\"og_image_scmp_fact_check\",\"og_image_scmp_live\",\"og_image_scmp_obituary\",\"og_image_scmp_opinion\",\"og_image_scmp_review\",\"og_image_scmp_series\",\"og_image_scmp_generic\"]})"
                          },
                          (v82/*: any*/),
                          {
                            "alias": null,
                            "args": (v83/*: any*/),
                            "concreteType": "ImageStyle",
                            "kind": "LinkedField",
                            "name": "style",
                            "plural": false,
                            "selections": (v62/*: any*/),
                            "storageKey": "style(filter:{\"style\":\"768x768\"})"
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isSlideshow",
                            "storageKey": null
                          },
                          (v61/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v84/*: any*/),
                      (v85/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "FormattedValue",
                        "kind": "LinkedField",
                        "name": "subHeadline",
                        "plural": false,
                        "selections": (v59/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": [
                          (v28/*: any*/),
                          {
                            "kind": "Literal",
                            "name": "type",
                            "value": "PARAGRAPH"
                          }
                        ],
                        "concreteType": "FormattedValue",
                        "kind": "LinkedField",
                        "name": "body",
                        "plural": false,
                        "selections": (v59/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "keywords",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Topic",
                        "kind": "LinkedField",
                        "name": "topics",
                        "plural": true,
                        "selections": (v31/*: any*/),
                        "storageKey": null
                      },
                      (v86/*: any*/),
                      (v87/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ArticleSpeech",
                        "kind": "LinkedField",
                        "name": "articleSpeeches",
                        "plural": true,
                        "selections": [
                          (v61/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "voiceName",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v88/*: any*/),
                      (v41/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Topic",
                        "kind": "LinkedField",
                        "name": "firstTopic",
                        "plural": false,
                        "selections": (v67/*: any*/),
                        "storageKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Topic",
                            "kind": "LinkedField",
                            "name": "topics",
                            "plural": true,
                            "selections": [
                              (v89/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ArticleTypeSegment",
                                "kind": "LinkedField",
                                "name": "types",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ArticleType",
                                    "kind": "LinkedField",
                                    "name": "value",
                                    "plural": true,
                                    "selections": [
                                      (v60/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v91/*: any*/),
                              (v76/*: any*/)
                            ],
                            "type": "Article",
                            "abstractKey": null
                          },
                          (v93/*: any*/)
                        ],
                        "type": "Content",
                        "abstractKey": "__isContent"
                      }
                    ],
                    "type": "Article",
                    "abstractKey": null
                  },
                  (v93/*: any*/)
                ],
                "type": "Content",
                "abstractKey": "__isContent"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SectionSegmentV2",
                    "kind": "LinkedField",
                    "name": "sectionsV2",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "value",
                        "plural": true,
                        "selections": [
                          (v25/*: any*/),
                          (v44/*: any*/),
                          (v66/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "type": "Article",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Section",
                    "kind": "LinkedField",
                    "name": "fullSectionPath",
                    "plural": true,
                    "selections": [
                      (v30/*: any*/),
                      (v38/*: any*/),
                      (v64/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "type": "Section",
                "abstractKey": null
              }
            ],
            "type": "BaseWithApplicationAndUrlAlias",
            "abstractKey": "__isBaseWithApplicationAndUrlAlias"
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "KeyValuePair",
                "kind": "LinkedField",
                "name": "metatags",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "key",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "value",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "DynamicMetaTags",
            "abstractKey": "__isDynamicMetaTags"
          }
        ],
        "storageKey": null
      },
      {
        "condition": "isSkipDefaultSubSectionQuery",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "alias": "subSection",
            "args": (v24/*: any*/),
            "concreteType": "Section",
            "kind": "LinkedField",
            "name": "section",
            "plural": false,
            "selections": [
              (v96/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "FormattedValue",
                "kind": "LinkedField",
                "name": "description",
                "plural": false,
                "selections": (v98/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": "relatedTopics",
            "args": [
              {
                "fields": [
                  {
                    "kind": "Variable",
                    "name": "name",
                    "variableName": "relatedTopicsQueueName"
                  }
                ],
                "kind": "ObjectValue",
                "name": "filter"
              }
            ],
            "concreteType": "Queue",
            "kind": "LinkedField",
            "name": "queue",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "QueueItemConnection",
                "kind": "LinkedField",
                "name": "items",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "QueueItemsEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v25/*: any*/),
                          (v99/*: any*/),
                          (v101/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": (v100/*: any*/),
                            "type": "VideoSection",
                            "abstractKey": null
                          },
                          (v102/*: any*/),
                          (v66/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v64/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": "articles",
            "args": (v103/*: any*/),
            "concreteType": "Queue",
            "kind": "LinkedField",
            "name": "queue",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v104/*: any*/),
                "concreteType": "QueueItemConnection",
                "kind": "LinkedField",
                "name": "items",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "QueueItemsEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v25/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v30/*: any*/),
                              (v37/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Topic",
                                "kind": "LinkedField",
                                "name": "topics",
                                "plural": true,
                                "selections": [
                                  (v30/*: any*/),
                                  (v89/*: any*/),
                                  (v64/*: any*/),
                                  (v105/*: any*/),
                                  (v37/*: any*/),
                                  (v38/*: any*/),
                                  (v106/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v25/*: any*/),
                                      (v42/*: any*/),
                                      (v69/*: any*/),
                                      (v71/*: any*/),
                                      (v72/*: any*/),
                                      (v75/*: any*/),
                                      (v78/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": (v108/*: any*/),
                                        "type": "Author",
                                        "abstractKey": null
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": (v108/*: any*/),
                                        "type": "Topic",
                                        "abstractKey": null
                                      }
                                    ],
                                    "type": "BaseWithApplicationAndUrlAlias",
                                    "abstractKey": "__isBaseWithApplicationAndUrlAlias"
                                  }
                                ],
                                "storageKey": null
                              },
                              (v109/*: any*/),
                              (v84/*: any*/),
                              (v68/*: any*/),
                              (v86/*: any*/),
                              (v26/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Image",
                                "kind": "LinkedField",
                                "name": "images",
                                "plural": true,
                                "selections": [
                                  (v61/*: any*/),
                                  (v110/*: any*/),
                                  (v82/*: any*/),
                                  (v112/*: any*/),
                                  (v113/*: any*/),
                                  (v114/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v27/*: any*/),
                              (v88/*: any*/),
                              (v115/*: any*/),
                              (v116/*: any*/),
                              (v117/*: any*/),
                              (v65/*: any*/),
                              (v119/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v76/*: any*/),
                                  (v73/*: any*/),
                                  (v74/*: any*/),
                                  (v120/*: any*/),
                                  (v122/*: any*/),
                                  (v80/*: any*/),
                                  (v87/*: any*/),
                                  (v123/*: any*/),
                                  (v124/*: any*/),
                                  (v125/*: any*/),
                                  (v126/*: any*/),
                                  (v105/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Image",
                                    "kind": "LinkedField",
                                    "name": "leadingSlides",
                                    "plural": true,
                                    "selections": [
                                      (v61/*: any*/),
                                      (v110/*: any*/),
                                      (v82/*: any*/),
                                      (v114/*: any*/),
                                      (v113/*: any*/),
                                      (v112/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v127/*: any*/)
                                ],
                                "type": "Article",
                                "abstractKey": null
                              },
                              (v130/*: any*/)
                            ],
                            "type": "Content",
                            "abstractKey": "__isContent"
                          },
                          (v66/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v131/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v132/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v104/*: any*/),
                "filters": null,
                "handle": "connection",
                "key": "subSectionIndexArticleListQuery__items",
                "kind": "LinkedHandle",
                "name": "items"
              },
              (v64/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": "parentSection",
            "args": (v133/*: any*/),
            "concreteType": "Section",
            "kind": "LinkedField",
            "name": "section",
            "plural": false,
            "selections": (v70/*: any*/),
            "storageKey": null
          },
          {
            "alias": "hundredTopTablesLast7Days",
            "args": [
              {
                "kind": "Literal",
                "name": "filter",
                "value": {
                  "name": "scmp_trending_section_scmp_trending_section_100_top_tables_last_7_days"
                }
              }
            ],
            "concreteType": "Queue",
            "kind": "LinkedField",
            "name": "queue",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v134/*: any*/),
                "concreteType": "QueueItemConnection",
                "kind": "LinkedField",
                "name": "items",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "QueueItemsEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v25/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v30/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v109/*: any*/),
                                  (v84/*: any*/),
                                  (v68/*: any*/),
                                  (v86/*: any*/),
                                  (v26/*: any*/),
                                  (v136/*: any*/),
                                  (v27/*: any*/),
                                  (v88/*: any*/),
                                  (v137/*: any*/),
                                  (v138/*: any*/),
                                  (v139/*: any*/),
                                  (v140/*: any*/)
                                ],
                                "type": "Content",
                                "abstractKey": "__isContent"
                              }
                            ],
                            "type": "Article",
                            "abstractKey": null
                          },
                          (v66/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "items(first:5)"
              },
              (v64/*: any*/)
            ],
            "storageKey": "queue(filter:{\"name\":\"scmp_trending_section_scmp_trending_section_100_top_tables_last_7_days\"})"
          },
          {
            "alias": "hundredTopTablesSponsor",
            "args": [
              {
                "kind": "Literal",
                "name": "filter",
                "value": {
                  "name": "discovery_module_discovery_module_517759"
                }
              }
            ],
            "concreteType": "Queue",
            "kind": "LinkedField",
            "name": "queue",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v141/*: any*/),
                "concreteType": "QueueItemConnection",
                "kind": "LinkedField",
                "name": "items",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "QueueItemsEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v25/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v30/*: any*/),
                                  (v109/*: any*/),
                                  (v84/*: any*/),
                                  (v68/*: any*/),
                                  (v86/*: any*/),
                                  (v26/*: any*/),
                                  (v136/*: any*/),
                                  (v27/*: any*/),
                                  (v88/*: any*/),
                                  (v137/*: any*/),
                                  (v138/*: any*/),
                                  (v139/*: any*/),
                                  (v140/*: any*/)
                                ],
                                "type": "Content",
                                "abstractKey": "__isContent"
                              }
                            ],
                            "type": "Article",
                            "abstractKey": null
                          },
                          (v66/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "items(first:1)"
              },
              (v64/*: any*/)
            ],
            "storageKey": "queue(filter:{\"name\":\"discovery_module_discovery_module_517759\"})"
          },
          {
            "alias": "hundredTopTablesSection",
            "args": [
              {
                "kind": "Literal",
                "name": "filter",
                "value": {
                  "entityId": "517759"
                }
              }
            ],
            "concreteType": "Section",
            "kind": "LinkedField",
            "name": "section",
            "plural": false,
            "selections": (v142/*: any*/),
            "storageKey": "section(filter:{\"entityId\":\"517759\"})"
          },
          {
            "alias": "openQuestionSeriesTopic",
            "args": [
              {
                "kind": "Literal",
                "name": "filter",
                "value": {
                  "entityId": "518656"
                }
              }
            ],
            "concreteType": "Topic",
            "kind": "LinkedField",
            "name": "topic",
            "plural": false,
            "selections": [
              (v38/*: any*/),
              (v37/*: any*/),
              {
                "alias": null,
                "args": [
                  {
                    "fields": [
                      {
                        "kind": "Variable",
                        "name": "paywallTypeIds",
                        "variableName": "scmpPlusPaywallTypeIds"
                      }
                    ],
                    "kind": "ObjectValue",
                    "name": "exclude"
                  },
                  (v143/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "orderBy",
                    "value": {
                      "direction": "DESC",
                      "field": "PUBLISHED_DATE"
                    }
                  }
                ],
                "concreteType": "ContentConnection",
                "kind": "LinkedField",
                "name": "contents",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ContentEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v25/*: any*/),
                          (v64/*: any*/),
                          (v146/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v64/*: any*/)
            ],
            "storageKey": "topic(filter:{\"entityId\":\"518656\"})"
          },
          {
            "alias": null,
            "args": (v24/*: any*/),
            "concreteType": "Section",
            "kind": "LinkedField",
            "name": "section",
            "plural": false,
            "selections": (v70/*: any*/),
            "storageKey": null
          },
          {
            "condition": "hasParentSection",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": "parentSection",
                "args": (v133/*: any*/),
                "concreteType": "Section",
                "kind": "LinkedField",
                "name": "section",
                "plural": false,
                "selections": [
                  (v38/*: any*/),
                  (v81/*: any*/)
                ],
                "storageKey": null
              }
            ]
          },
          {
            "condition": "includeComment",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": "commentSection",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "filter",
                    "value": {
                      "entityId": "93"
                    }
                  }
                ],
                "concreteType": "Section",
                "kind": "LinkedField",
                "name": "section",
                "plural": false,
                "selections": [
                  (v37/*: any*/),
                  (v64/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v25/*: any*/),
                      (v30/*: any*/),
                      (v46/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": (v147/*: any*/),
                        "type": "Author",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v147/*: any*/),
                        "type": "Topic",
                        "abstractKey": null
                      }
                    ],
                    "type": "BaseWithApplicationAndUrlAlias",
                    "abstractKey": "__isBaseWithApplicationAndUrlAlias"
                  }
                ],
                "storageKey": "section(filter:{\"entityId\":\"93\"})"
              },
              {
                "alias": "commentQueue",
                "args": [
                  {
                    "fields": [
                      {
                        "kind": "Variable",
                        "name": "name",
                        "variableName": "commentQueueName"
                      }
                    ],
                    "kind": "ObjectValue",
                    "name": "filter"
                  }
                ],
                "concreteType": "Queue",
                "kind": "LinkedField",
                "name": "queue",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": (v148/*: any*/),
                    "concreteType": "QueueItemConnection",
                    "kind": "LinkedField",
                    "name": "items",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "QueueItemsEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v25/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v30/*: any*/),
                                  (v37/*: any*/),
                                  (v109/*: any*/),
                                  (v84/*: any*/),
                                  (v68/*: any*/),
                                  (v86/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Author",
                                    "kind": "LinkedField",
                                    "name": "authors",
                                    "plural": true,
                                    "selections": [
                                      (v30/*: any*/),
                                      (v42/*: any*/),
                                      (v38/*: any*/),
                                      {
                                        "alias": null,
                                        "args": [
                                          {
                                            "kind": "Literal",
                                            "name": "filter",
                                            "value": {
                                              "type": "AUTHOR_IMAGE"
                                            }
                                          }
                                        ],
                                        "concreteType": "Image",
                                        "kind": "LinkedField",
                                        "name": "image",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": [
                                              {
                                                "kind": "Literal",
                                                "name": "filter",
                                                "value": {
                                                  "style": "300x300"
                                                }
                                              }
                                            ],
                                            "concreteType": "ImageStyle",
                                            "kind": "LinkedField",
                                            "name": "style",
                                            "plural": false,
                                            "selections": (v62/*: any*/),
                                            "storageKey": "style(filter:{\"style\":\"300x300\"})"
                                          }
                                        ],
                                        "storageKey": "image(filter:{\"type\":\"AUTHOR_IMAGE\"})"
                                      },
                                      (v64/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v25/*: any*/),
                                          (v37/*: any*/),
                                          (v69/*: any*/),
                                          (v71/*: any*/),
                                          (v72/*: any*/),
                                          (v75/*: any*/),
                                          (v78/*: any*/)
                                        ],
                                        "type": "BaseWithApplicationAndUrlAlias",
                                        "abstractKey": "__isBaseWithApplicationAndUrlAlias"
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  (v88/*: any*/),
                                  (v26/*: any*/),
                                  (v27/*: any*/),
                                  (v137/*: any*/),
                                  (v138/*: any*/),
                                  (v119/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v87/*: any*/),
                                      (v123/*: any*/),
                                      (v124/*: any*/),
                                      (v125/*: any*/),
                                      (v91/*: any*/),
                                      (v80/*: any*/),
                                      (v127/*: any*/)
                                    ],
                                    "type": "Article",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v128/*: any*/),
                                      {
                                        "alias": null,
                                        "args": [
                                          {
                                            "kind": "Literal",
                                            "name": "filter",
                                            "value": {
                                              "type": "MAIN_IMAGE"
                                            }
                                          }
                                        ],
                                        "concreteType": "Image",
                                        "kind": "LinkedField",
                                        "name": "image",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "alt",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": (v111/*: any*/),
                                            "concreteType": "ImageStyle",
                                            "kind": "LinkedField",
                                            "name": "style",
                                            "plural": false,
                                            "selections": (v62/*: any*/),
                                            "storageKey": "style(filter:{\"style\":\"1200x800\"})"
                                          }
                                        ],
                                        "storageKey": "image(filter:{\"type\":\"MAIN_IMAGE\"})"
                                      }
                                    ],
                                    "type": "Video",
                                    "abstractKey": null
                                  }
                                ],
                                "type": "Content",
                                "abstractKey": "__isContent"
                              },
                              (v66/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "items(first:6)"
                  },
                  (v64/*: any*/)
                ],
                "storageKey": null
              }
            ]
          },
          {
            "condition": "includePostMagazine",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": "postMagazineLast7Days",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "filter",
                    "value": {
                      "name": "scmp_trending_section_scmp_trending_section_postmag_last_7_days"
                    }
                  }
                ],
                "concreteType": "Queue",
                "kind": "LinkedField",
                "name": "queue",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": (v148/*: any*/),
                    "concreteType": "QueueItemConnection",
                    "kind": "LinkedField",
                    "name": "items",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "QueueItemsEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v25/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v30/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v37/*: any*/),
                                      (v138/*: any*/),
                                      (v26/*: any*/),
                                      (v145/*: any*/),
                                      (v27/*: any*/),
                                      (v88/*: any*/),
                                      (v137/*: any*/),
                                      (v85/*: any*/),
                                      (v86/*: any*/),
                                      (v151/*: any*/),
                                      (v150/*: any*/),
                                      (v152/*: any*/)
                                    ],
                                    "type": "Content",
                                    "abstractKey": "__isContent"
                                  }
                                ],
                                "type": "Article",
                                "abstractKey": null
                              },
                              (v66/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "items(first:6)"
                  },
                  (v64/*: any*/)
                ],
                "storageKey": "queue(filter:{\"name\":\"scmp_trending_section_scmp_trending_section_postmag_last_7_days\"})"
              },
              {
                "alias": "postMagazineSponsor",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "filter",
                    "value": {
                      "name": "discovery_module_discovery_module_71"
                    }
                  }
                ],
                "concreteType": "Queue",
                "kind": "LinkedField",
                "name": "queue",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": (v141/*: any*/),
                    "concreteType": "QueueItemConnection",
                    "kind": "LinkedField",
                    "name": "items",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "QueueItemsEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v25/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v30/*: any*/),
                                      (v37/*: any*/),
                                      (v138/*: any*/),
                                      (v26/*: any*/),
                                      (v145/*: any*/),
                                      (v27/*: any*/),
                                      (v88/*: any*/),
                                      (v137/*: any*/),
                                      (v85/*: any*/),
                                      (v86/*: any*/),
                                      (v151/*: any*/),
                                      (v150/*: any*/),
                                      (v152/*: any*/)
                                    ],
                                    "type": "Content",
                                    "abstractKey": "__isContent"
                                  }
                                ],
                                "type": "Article",
                                "abstractKey": null
                              },
                              (v66/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "items(first:1)"
                  },
                  (v64/*: any*/)
                ],
                "storageKey": "queue(filter:{\"name\":\"discovery_module_discovery_module_71\"})"
              },
              {
                "alias": "postMagazineSection",
                "args": (v153/*: any*/),
                "concreteType": "Section",
                "kind": "LinkedField",
                "name": "section",
                "plural": false,
                "selections": (v142/*: any*/),
                "storageKey": "section(filter:{\"entityId\":\"71\"})"
              }
            ]
          },
          {
            "condition": "includeMultimedia",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": "multimedia",
                "args": [
                  {
                    "fields": [
                      {
                        "kind": "Variable",
                        "name": "name",
                        "variableName": "multimediaQueueName"
                      }
                    ],
                    "kind": "ObjectValue",
                    "name": "filter"
                  }
                ],
                "concreteType": "Queue",
                "kind": "LinkedField",
                "name": "queue",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "first",
                        "value": 4
                      }
                    ],
                    "concreteType": "QueueItemConnection",
                    "kind": "LinkedField",
                    "name": "items",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "QueueItemsEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v25/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ArticleTypeSegment",
                                    "kind": "LinkedField",
                                    "name": "types",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ArticleType",
                                        "kind": "LinkedField",
                                        "name": "value",
                                        "plural": true,
                                        "selections": (v67/*: any*/),
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "type": "Article",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v30/*: any*/),
                                  (v37/*: any*/),
                                  (v26/*: any*/),
                                  (v145/*: any*/),
                                  (v27/*: any*/),
                                  (v88/*: any*/),
                                  (v137/*: any*/),
                                  (v138/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Image",
                                        "kind": "LinkedField",
                                        "name": "images",
                                        "plural": true,
                                        "selections": [
                                          (v25/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "Gallery",
                                    "abstractKey": null
                                  },
                                  (v119/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ArticleTypeSegment",
                                        "kind": "LinkedField",
                                        "name": "types",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "ArticleType",
                                            "kind": "LinkedField",
                                            "name": "value",
                                            "plural": true,
                                            "selections": [
                                              (v30/*: any*/),
                                              (v60/*: any*/)
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "SectionSegmentV2",
                                        "kind": "LinkedField",
                                        "name": "sectionsV2",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": null,
                                            "kind": "LinkedField",
                                            "name": "value",
                                            "plural": true,
                                            "selections": [
                                              (v25/*: any*/),
                                              (v46/*: any*/),
                                              (v66/*: any*/)
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      },
                                      (v126/*: any*/),
                                      (v80/*: any*/),
                                      (v154/*: any*/),
                                      (v127/*: any*/)
                                    ],
                                    "type": "Article",
                                    "abstractKey": null
                                  },
                                  (v152/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "PodcastSection",
                                        "kind": "LinkedField",
                                        "name": "podcastSections",
                                        "plural": true,
                                        "selections": [
                                          (v154/*: any*/),
                                          (v38/*: any*/),
                                          (v64/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "Podcast",
                                    "abstractKey": null
                                  }
                                ],
                                "type": "Content",
                                "abstractKey": "__isContent"
                              },
                              (v66/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "items(first:4)"
                  },
                  (v64/*: any*/)
                ],
                "storageKey": null
              }
            ]
          },
          {
            "condition": "includeChinaFutureTechDiscovery",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": "chinaFutureTechSection",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "filter",
                    "value": {
                      "entityId": "519735"
                    }
                  }
                ],
                "concreteType": "Section",
                "kind": "LinkedField",
                "name": "section",
                "plural": false,
                "selections": [
                  (v37/*: any*/),
                  (v38/*: any*/),
                  (v30/*: any*/),
                  (v63/*: any*/),
                  (v96/*: any*/),
                  (v64/*: any*/)
                ],
                "storageKey": "section(filter:{\"entityId\":\"519735\"})"
              },
              {
                "alias": "chinaFutureTechQueue",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "filter",
                    "value": {
                      "name": "section_top_519735"
                    }
                  }
                ],
                "concreteType": "Queue",
                "kind": "LinkedField",
                "name": "queue",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": (v148/*: any*/),
                    "concreteType": "QueueItemConnection",
                    "kind": "LinkedField",
                    "name": "items",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "QueueItemsEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v25/*: any*/),
                              (v146/*: any*/),
                              (v66/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "items(first:6)"
                  },
                  (v64/*: any*/)
                ],
                "storageKey": "queue(filter:{\"name\":\"section_top_519735\"})"
              }
            ]
          },
          {
            "condition": "includeFocusArticle",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": "focus",
                "args": [
                  {
                    "fields": [
                      {
                        "kind": "Variable",
                        "name": "name",
                        "variableName": "focusQueueName"
                      }
                    ],
                    "kind": "ObjectValue",
                    "name": "filter"
                  }
                ],
                "concreteType": "Queue",
                "kind": "LinkedField",
                "name": "queue",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "settings",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": (v141/*: any*/),
                    "concreteType": "QueueItemConnection",
                    "kind": "LinkedField",
                    "name": "items",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "QueueItemsEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v25/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v30/*: any*/),
                                  (v26/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Image",
                                    "kind": "LinkedField",
                                    "name": "images",
                                    "plural": true,
                                    "selections": [
                                      (v61/*: any*/),
                                      (v110/*: any*/),
                                      (v82/*: any*/),
                                      {
                                        "alias": "size1280x720",
                                        "args": [
                                          {
                                            "kind": "Literal",
                                            "name": "filter",
                                            "value": {
                                              "style": "wide_landscape"
                                            }
                                          }
                                        ],
                                        "concreteType": "ImageStyle",
                                        "kind": "LinkedField",
                                        "name": "style",
                                        "plural": false,
                                        "selections": (v62/*: any*/),
                                        "storageKey": "style(filter:{\"style\":\"wide_landscape\"})"
                                      },
                                      {
                                        "alias": "size640x360",
                                        "args": [
                                          {
                                            "kind": "Literal",
                                            "name": "filter",
                                            "value": {
                                              "style": "wide_landscape_640_360"
                                            }
                                          }
                                        ],
                                        "concreteType": "ImageStyle",
                                        "kind": "LinkedField",
                                        "name": "style",
                                        "plural": false,
                                        "selections": (v62/*: any*/),
                                        "storageKey": "style(filter:{\"style\":\"wide_landscape_640_360\"})"
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  (v27/*: any*/),
                                  (v88/*: any*/),
                                  (v137/*: any*/),
                                  (v138/*: any*/),
                                  (v37/*: any*/),
                                  (v119/*: any*/),
                                  (v152/*: any*/),
                                  (v155/*: any*/)
                                ],
                                "type": "Content",
                                "abstractKey": "__isContent"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ArticleTypeSegment",
                                    "kind": "LinkedField",
                                    "name": "types",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ArticleType",
                                        "kind": "LinkedField",
                                        "name": "value",
                                        "plural": true,
                                        "selections": (v70/*: any*/),
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "SectionSegmentV2",
                                    "kind": "LinkedField",
                                    "name": "sectionsV2",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": null,
                                        "kind": "LinkedField",
                                        "name": "value",
                                        "plural": true,
                                        "selections": [
                                          (v25/*: any*/),
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v30/*: any*/),
                                              (v38/*: any*/),
                                              (v37/*: any*/),
                                              {
                                                "alias": null,
                                                "args": (v94/*: any*/),
                                                "concreteType": "Image",
                                                "kind": "LinkedField",
                                                "name": "image",
                                                "plural": false,
                                                "selections": (v95/*: any*/),
                                                "storageKey": "image(filter:{\"type\":\"TERM_LOGO\"})"
                                              }
                                            ],
                                            "type": "Section",
                                            "abstractKey": null
                                          },
                                          (v66/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  (v73/*: any*/),
                                  (v74/*: any*/)
                                ],
                                "type": "Article",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "SectionSegmentV2",
                                    "kind": "LinkedField",
                                    "name": "sectionsV2",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": null,
                                        "kind": "LinkedField",
                                        "name": "value",
                                        "plural": true,
                                        "selections": [
                                          (v25/*: any*/),
                                          (v34/*: any*/),
                                          (v66/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "type": "Video",
                                "abstractKey": null
                              },
                              (v66/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "items(first:1)"
                  },
                  (v64/*: any*/)
                ],
                "storageKey": null
              }
            ]
          }
        ]
      },
      {
        "condition": "isStyleSubSection",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": "relatedSections",
            "args": [
              {
                "fields": [
                  {
                    "kind": "Variable",
                    "name": "name",
                    "variableName": "relatedSectionsQueueName"
                  }
                ],
                "kind": "ObjectValue",
                "name": "filter"
              }
            ],
            "concreteType": "Queue",
            "kind": "LinkedField",
            "name": "queue",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 10
                  }
                ],
                "concreteType": "QueueItemConnection",
                "kind": "LinkedField",
                "name": "items",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "QueueItemsEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v25/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v38/*: any*/),
                              (v30/*: any*/)
                            ],
                            "type": "Section",
                            "abstractKey": null
                          },
                          (v102/*: any*/),
                          (v66/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "items(first:10)"
              },
              (v64/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v24/*: any*/),
            "concreteType": "Section",
            "kind": "LinkedField",
            "name": "section",
            "plural": false,
            "selections": [
              (v38/*: any*/),
              (v63/*: any*/),
              (v156/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Section",
                "kind": "LinkedField",
                "name": "fullSectionPath",
                "plural": true,
                "selections": [
                  (v38/*: any*/),
                  (v42/*: any*/),
                  (v156/*: any*/),
                  (v64/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v25/*: any*/),
                      (v30/*: any*/),
                      (v37/*: any*/),
                      (v69/*: any*/),
                      (v71/*: any*/),
                      (v72/*: any*/),
                      (v75/*: any*/),
                      (v78/*: any*/)
                    ],
                    "type": "BaseWithApplicationAndUrlAlias",
                    "abstractKey": "__isBaseWithApplicationAndUrlAlias"
                  }
                ],
                "storageKey": null
              },
              (v64/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v25/*: any*/),
                  (v30/*: any*/),
                  (v42/*: any*/),
                  (v37/*: any*/),
                  (v69/*: any*/),
                  (v71/*: any*/),
                  (v53/*: any*/),
                  (v75/*: any*/),
                  (v78/*: any*/)
                ],
                "type": "BaseWithApplicationAndUrlAlias",
                "abstractKey": "__isBaseWithApplicationAndUrlAlias"
              }
            ],
            "storageKey": null
          },
          {
            "alias": "sectionArticles",
            "args": (v103/*: any*/),
            "concreteType": "Queue",
            "kind": "LinkedField",
            "name": "queue",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v104/*: any*/),
                "concreteType": "QueueItemConnection",
                "kind": "LinkedField",
                "name": "items",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "QueueItemsEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v25/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Topic",
                                    "kind": "LinkedField",
                                    "name": "topics",
                                    "plural": true,
                                    "selections": [
                                      (v30/*: any*/),
                                      (v38/*: any*/),
                                      (v106/*: any*/),
                                      (v64/*: any*/),
                                      (v89/*: any*/),
                                      (v81/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v26/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Image",
                                    "kind": "LinkedField",
                                    "name": "images",
                                    "plural": true,
                                    "selections": [
                                      (v61/*: any*/),
                                      (v110/*: any*/),
                                      (v82/*: any*/),
                                      (v112/*: any*/),
                                      {
                                        "alias": "size1200x1200",
                                        "args": [
                                          {
                                            "kind": "Literal",
                                            "name": "filter",
                                            "value": {
                                              "style": "1200x1200"
                                            }
                                          }
                                        ],
                                        "concreteType": "ImageStyle",
                                        "kind": "LinkedField",
                                        "name": "style",
                                        "plural": false,
                                        "selections": (v62/*: any*/),
                                        "storageKey": "style(filter:{\"style\":\"1200x1200\"})"
                                      },
                                      (v113/*: any*/),
                                      {
                                        "alias": "size500x500",
                                        "args": [
                                          {
                                            "kind": "Literal",
                                            "name": "filter",
                                            "value": {
                                              "style": "500x500"
                                            }
                                          }
                                        ],
                                        "concreteType": "ImageStyle",
                                        "kind": "LinkedField",
                                        "name": "style",
                                        "plural": false,
                                        "selections": (v62/*: any*/),
                                        "storageKey": "style(filter:{\"style\":\"500x500\"})"
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  (v27/*: any*/),
                                  (v88/*: any*/),
                                  (v137/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v30/*: any*/),
                                      (v42/*: any*/),
                                      (v37/*: any*/),
                                      (v69/*: any*/),
                                      (v71/*: any*/),
                                      (v72/*: any*/),
                                      (v75/*: any*/),
                                      (v118/*: any*/)
                                    ],
                                    "type": "BaseWithApplicationAndUrlAlias",
                                    "abstractKey": "__isBaseWithApplicationAndUrlAlias"
                                  },
                                  (v155/*: any*/)
                                ],
                                "type": "Content",
                                "abstractKey": "__isContent"
                              }
                            ],
                            "type": "Article",
                            "abstractKey": null
                          },
                          (v66/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v131/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v132/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v104/*: any*/),
                "filters": null,
                "handle": "connection",
                "key": "styleSectionArticleListQuery__items",
                "kind": "LinkedHandle",
                "name": "items"
              },
              (v64/*: any*/)
            ],
            "storageKey": null
          }
        ]
      },
      {
        "condition": "isPostMagazineSubSection",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": "articles",
            "args": (v103/*: any*/),
            "concreteType": "Queue",
            "kind": "LinkedField",
            "name": "queue",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v104/*: any*/),
                "concreteType": "QueueItemConnection",
                "kind": "LinkedField",
                "name": "items",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "QueueItemsEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v25/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v30/*: any*/),
                              (v37/*: any*/),
                              (v157/*: any*/),
                              (v26/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Image",
                                "kind": "LinkedField",
                                "name": "images",
                                "plural": true,
                                "selections": [
                                  (v61/*: any*/),
                                  (v110/*: any*/),
                                  (v82/*: any*/),
                                  (v112/*: any*/),
                                  (v135/*: any*/),
                                  (v113/*: any*/),
                                  (v114/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v27/*: any*/),
                              (v88/*: any*/),
                              (v137/*: any*/),
                              (v119/*: any*/),
                              (v158/*: any*/)
                            ],
                            "type": "Content",
                            "abstractKey": "__isContent"
                          },
                          (v66/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v131/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v132/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v104/*: any*/),
                "filters": null,
                "handle": "connection",
                "key": "subSectionPostMagazineIndexArticleListQuery__items",
                "kind": "LinkedHandle",
                "name": "items"
              },
              (v64/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": "sponsorQueue",
            "args": [
              {
                "fields": [
                  {
                    "kind": "Variable",
                    "name": "name",
                    "variableName": "sponsorQueueName"
                  }
                ],
                "kind": "ObjectValue",
                "name": "filter"
              }
            ],
            "concreteType": "Queue",
            "kind": "LinkedField",
            "name": "queue",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": [
                  (v56/*: any*/)
                ],
                "concreteType": "QueueItemConnection",
                "kind": "LinkedField",
                "name": "items",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "QueueItemsEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v25/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v30/*: any*/),
                              (v37/*: any*/),
                              (v157/*: any*/),
                              (v26/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Image",
                                "kind": "LinkedField",
                                "name": "images",
                                "plural": true,
                                "selections": [
                                  (v61/*: any*/),
                                  (v110/*: any*/),
                                  (v82/*: any*/),
                                  (v112/*: any*/),
                                  (v135/*: any*/),
                                  (v113/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v27/*: any*/),
                              (v88/*: any*/),
                              (v137/*: any*/),
                              (v119/*: any*/),
                              (v158/*: any*/)
                            ],
                            "type": "Content",
                            "abstractKey": "__isContent"
                          },
                          (v66/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v64/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v24/*: any*/),
            "concreteType": "Section",
            "kind": "LinkedField",
            "name": "section",
            "plural": false,
            "selections": [
              (v30/*: any*/),
              (v57/*: any*/),
              (v64/*: any*/),
              (v38/*: any*/),
              (v60/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": "postMagSection",
            "args": (v153/*: any*/),
            "concreteType": "Section",
            "kind": "LinkedField",
            "name": "section",
            "plural": false,
            "selections": [
              (v37/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Queue",
                "kind": "LinkedField",
                "name": "subSections",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "QueueItemConnection",
                    "kind": "LinkedField",
                    "name": "items",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "QueueItemsEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v25/*: any*/),
                              (v99/*: any*/),
                              (v101/*: any*/),
                              (v102/*: any*/),
                              (v66/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v64/*: any*/)
                ],
                "storageKey": null
              },
              (v64/*: any*/)
            ],
            "storageKey": "section(filter:{\"entityId\":\"71\"})"
          },
          {
            "alias": "topicQueue",
            "args": [
              {
                "fields": [
                  {
                    "kind": "Variable",
                    "name": "name",
                    "variableName": "postMagazineSubSectionTopicQueueName"
                  }
                ],
                "kind": "ObjectValue",
                "name": "filter"
              }
            ],
            "concreteType": "Queue",
            "kind": "LinkedField",
            "name": "queue",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v134/*: any*/),
                "concreteType": "QueueItemConnection",
                "kind": "LinkedField",
                "name": "items",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "QueueItemsEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v25/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v30/*: any*/),
                              (v38/*: any*/),
                              (v106/*: any*/),
                              (v79/*: any*/)
                            ],
                            "type": "Topic",
                            "abstractKey": null
                          },
                          (v66/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "items(first:5)"
              },
              (v64/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "filter",
                "value": {
                  "entityId": "322743"
                }
              }
            ],
            "concreteType": "Newsletter",
            "kind": "LinkedField",
            "name": "newsletter",
            "plural": false,
            "selections": [
              (v60/*: any*/),
              (v85/*: any*/),
              (v64/*: any*/)
            ],
            "storageKey": "newsletter(filter:{\"entityId\":\"322743\"})"
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "7d34d36437e8d563b6d196822c421561",
    "id": null,
    "metadata": {},
    "name": "subSectionPageQuery",
    "operationKind": "query",
    "text": "query subSectionPageQuery(\n  $after: String\n  $articlesQueueName: String!\n  $commentQueueName: String!\n  $customContents: [CustomContentInput]\n  $entityId: String!\n  $first: Int\n  $focusQueueName: String!\n  $isStyleSubSection: Boolean!\n  $isPostMagazineSubSection: Boolean!\n  $isSkipDefaultSubSectionQuery: Boolean!\n  $multimediaQueueName: String!\n  $relatedSectionsQueueName: String!\n  $scmpPlusPaywallTypeIds: [String]\n  $parentSectionUuid: String!\n  $relatedTopicsQueueName: String!\n  $postMagazineSubSectionTopicQueueName: String!\n  $hasParentSection: Boolean!\n  $sponsorQueueName: String!\n  $includeComment: Boolean!\n  $includeChinaFutureTechDiscovery: Boolean!\n  $includeFocusArticle: Boolean!\n  $includeMultimedia: Boolean!\n  $includePostMagazine: Boolean!\n) {\n  subSection: section(filter: {entityId: $entityId}) {\n    ...contextsSectionContextProviderSection\n    ...sectionSeoSection\n    ...hooksTrackCurrentItemBase_4oKxOH\n    id\n  }\n  ...subSectionQuery_4vrZbj @skip(if: $isSkipDefaultSubSectionQuery)\n  ...subSectionStyleContentQuery_1HvVap @include(if: $isStyleSubSection)\n  ...subSectionPostMagazineQuery_414Qbb @include(if: $isPostMagazineSubSection)\n}\n\nfragment articleCommentArticle on Article {\n  ...entityLink\n  commentCount\n  entityId\n}\n\nfragment articleCommentsTriggerArticle on Article {\n  commentCount\n  entityId\n  ...helpersUseContentSponsorContent\n}\n\nfragment articleHeadlineHeaderFeaturesContent on Content {\n  __isContent: __typename\n  headline\n  socialHeadline\n}\n\nfragment articleSeoArticle_3GTCBR on Article {\n  ...hooksArticleSeoArticle\n  ...helpersGetArticleTypeArticle\n  entityId\n  publishedDate\n  updatedDate\n  summary {\n    text\n  }\n  subHeadline {\n    text\n  }\n  body(customContents: $customContents, type: PARAGRAPH) {\n    text\n  }\n  keywords\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        name\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n  topics {\n    name\n    entityId\n    id\n  }\n  urlAlias\n  authors {\n    name\n    id\n  }\n  images {\n    style(filter: {style: \"768x768\"}) {\n      url\n    }\n  }\n  readingTime\n}\n\nfragment articleShareWidgetArticle on Article {\n  ...contentShareWidgetContent\n  ...articleCommentsTriggerArticle\n  ...articleSpeechInlineWidgetArticle\n}\n\nfragment articleSpeechInlineWidgetArticle on Article {\n  ...genericArticleSpeechInlineWidgetGenericArticle\n  ...utilitiesGetHasArticleSpeechArticle\n}\n\nfragment atomsCurrentArticleAtomBase_3GTCBR on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  __typename\n  ... on Content {\n    __isContent: __typename\n    ...articleHeadlineHeaderFeaturesContent\n    ...articleSeoArticle_3GTCBR\n    ...articleShareWidgetArticle\n    ...bookmarkHeaderFeaturesContent\n    ...commentHeaderFeaturesArticle\n    ...contentShareWidgetContent\n    ...helpersCheckIsStyleArticle\n    ...helpersUseSharingUrl\n    ...hooksContentInterestArticle\n    ...hooksTrackPageViewArticle\n    ...hooksUseCurrentArticleIdsArticle\n    ...hooksUseCurrentArticlePrebidConfigArticle\n    ...hooksUsePageTargetingArticle\n    ...onboardingNewsletterSubscriptionArticle\n    ...entityLinkHeaderFeaturesArticle\n    ...shareHeaderFeaturesContent\n    ...helpersRosettaArticleContextArticle\n  }\n}\n\nfragment atomsCurrentShareContentAtomBase on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  __typename\n  ... on Article {\n    ...contentShareWidgetContent\n  }\n  ... on Video {\n    ...contentShareWidgetContent\n  }\n}\n\nfragment atomsCurrentStyleCardCarouselWidgetSectionsAtomBase on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  __typename\n  ... on Article {\n    sectionsV2 {\n      value {\n        __typename\n        ... on Section {\n          entityId\n          name\n        }\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n      }\n    }\n  }\n  ... on Section {\n    fullSectionPath {\n      entityId\n      name\n      id\n    }\n  }\n}\n\nfragment atomsCurrentTakeoverAdSectionsAtomBase on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  __typename\n  ... on Article {\n    sectionsV2 {\n      value {\n        __typename\n        ... on Section {\n          entityId\n        }\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n      }\n    }\n  }\n  ... on Section {\n    fullSectionPath {\n      entityId\n      id\n    }\n  }\n}\n\nfragment authorAvatarAuthor on Author {\n  ...entityLink\n  entityId\n  entityUuid\n  name\n  image(filter: {type: AUTHOR_IMAGE}) {\n    style(filter: {style: \"300x300\"}) {\n      url\n    }\n  }\n}\n\nfragment blockquoteQuoteContent on Content {\n  __isContent: __typename\n  ...contentShareWidgetContent\n}\n\nfragment bookmarkHeaderFeaturesContent on Content {\n  __isContent: __typename\n  entityId\n}\n\nfragment buttonArticleSpeechInlineWidgetGenericButtonArticle on Article {\n  entityId\n  socialHeadline\n  headline\n  articleSpeeches {\n    url\n    voiceName\n  }\n  images {\n    isSlideshow\n    url\n  }\n}\n\nfragment checkersCheckContentContainsStarlingImageContent on Content {\n  __isContent: __typename\n  topics {\n    entityId\n    id\n  }\n}\n\nfragment chinaFutureTechDiscoveryWidgetQuery on Query {\n  chinaFutureTechSection: section(filter: {entityId: \"519735\"}) {\n    ...latestDiscoveryWidgetSection\n    ...sectionTermLogoSection\n    urlAlias\n    name\n    id\n  }\n  chinaFutureTechQueue: queue(filter: {name: \"section_top_519735\"}) {\n    ...latestDiscoveryWidgetQueue\n    id\n  }\n}\n\nfragment commentContentItemContent on Content {\n  __isContent: __typename\n  entityId\n  urlAlias\n  ...entityLink\n  ...hooksContentItemProvidersContent_2RX0zR\n  ... on Video {\n    headline\n    duration\n    image(filter: {type: MAIN_IMAGE}) {\n      alt\n      style(filter: {style: \"1200x800\"}) {\n        url\n      }\n    }\n  }\n}\n\nfragment commentHeaderFeaturesArticle on Article {\n  ...articleCommentsTriggerArticle\n}\n\nfragment commentQueueQuery_2qpcKW on Query {\n  commentSection: section(filter: {entityId: \"93\"}) {\n    urlAlias\n    ...followButtonBase\n    id\n  }\n  commentQueue: queue(filter: {name: $commentQueueName}) {\n    items(first: 6) {\n      edges {\n        node {\n          __typename\n          ... on Content {\n            __isContent: __typename\n            entityId\n            ...commentContentItemContent\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment contentActionBarContent on Content {\n  __isContent: __typename\n  entityId\n  createdDate\n  updatedDate\n  publishedDate\n  readingTime\n  ...articleCommentArticle\n  ...helpersIsArticleVideoAsHeroArticle\n  ...helpersGetContentTypeNameContent\n  ... on Article {\n    hasVideoContent\n  }\n}\n\nfragment contentAuthorImageContent on Content {\n  __isContent: __typename\n  authors {\n    entityId\n    ...authorAvatarAuthor\n    ...entityLink\n    id\n  }\n  ...hooksContentHelperContent\n  ...helpersGetArticleTypeArticle\n}\n\nfragment contentAuthorLinkContent on Content {\n  __isContent: __typename\n  authors {\n    entityId\n    entityUuid\n    name\n    ...entityLink\n    id\n  }\n  ...hooksContentHelperContent\n}\n\nfragment contentCoverImageContent_1SslBT on Content {\n  __isContent: __typename\n  headline\n  images {\n    url\n    title\n    type\n    size1200x800: style(filter: {style: \"1200x800\"}) {\n      url\n    }\n    size540x360: style(filter: {style: \"540x360\"}) {\n      url\n    }\n  }\n  ... on Article {\n    leadingSlides {\n      url\n      title\n      type\n      size1200x800: style(filter: {style: \"1200x800\"}) {\n        url\n      }\n      size540x360: style(filter: {style: \"540x360\"}) {\n        url\n      }\n    }\n  }\n}\n\nfragment contentCoverImageContent_1g6fcK on Content {\n  __isContent: __typename\n  headline\n  images {\n    url\n    title\n    type\n    landscape250x99: style(filter: {style: \"landscape_250_99\"}) {\n      url\n    }\n    size540x360: style(filter: {style: \"540x360\"}) {\n      url\n    }\n  }\n}\n\nfragment contentCoverImageContent_2eYJyj on Content {\n  __isContent: __typename\n  headline\n  images {\n    url\n    title\n    type\n    landscape250x99: style(filter: {style: \"landscape_250_99\"}) {\n      url\n    }\n    size540x360: style(filter: {style: \"540x360\"}) {\n      url\n    }\n  }\n  ... on Article {\n    leadingSlides {\n      url\n      title\n      type\n      landscape250x99: style(filter: {style: \"landscape_250_99\"}) {\n        url\n      }\n      size540x360: style(filter: {style: \"540x360\"}) {\n        url\n      }\n    }\n  }\n}\n\nfragment contentCoverImageContent_2g6DLq on Content {\n  __isContent: __typename\n  headline\n  images {\n    url\n    title\n    type\n    size768x768: style(filter: {style: \"768x768\"}) {\n      url\n    }\n    size540x360: style(filter: {style: \"540x360\"}) {\n      url\n    }\n  }\n}\n\nfragment contentCoverImageContent_2ihLSb on Content {\n  __isContent: __typename\n  headline\n  images {\n    url\n    title\n    type\n    size1200x800: style(filter: {style: \"1200x800\"}) {\n      url\n    }\n    size540x360: style(filter: {style: \"540x360\"}) {\n      url\n    }\n  }\n}\n\nfragment contentCoverImageContent_2zNOHT on Content {\n  __isContent: __typename\n  headline\n  images {\n    url\n    title\n    type\n    size1280x720: style(filter: {style: \"wide_landscape\"}) {\n      url\n    }\n    size640x360: style(filter: {style: \"wide_landscape_640_360\"}) {\n      url\n    }\n  }\n}\n\nfragment contentCoverImageContent_3UtnDL on Content {\n  __isContent: __typename\n  headline\n  images {\n    url\n    title\n    type\n    size1200x800: style(filter: {style: \"1200x800\"}) {\n      url\n    }\n    size1200x1200: style(filter: {style: \"1200x1200\"}) {\n      url\n    }\n    size540x360: style(filter: {style: \"540x360\"}) {\n      url\n    }\n    size500x500: style(filter: {style: \"500x500\"}) {\n      url\n    }\n  }\n}\n\nfragment contentCoverImageContent_3i5ehM on Content {\n  __isContent: __typename\n  headline\n  images {\n    url\n    title\n    type\n    size1200x800: style(filter: {style: \"1200x800\"}) {\n      url\n    }\n    size768x768: style(filter: {style: \"768x768\"}) {\n      url\n    }\n    size540x360: style(filter: {style: \"540x360\"}) {\n      url\n    }\n  }\n}\n\nfragment contentHeadlineContent on Content {\n  __isContent: __typename\n  headline\n  socialHeadline\n  ...contentHeadlineTagContent\n  ...helpersUseContentSponsorContent\n}\n\nfragment contentHeadlineTagContent on Content {\n  __isContent: __typename\n  ...hooksContentHeadlineTagContent\n}\n\nfragment contentLiveTagContent on Article {\n  ...helpersCheckHasLiveTagArticle\n}\n\nfragment contentNewsletterWidgetContent on Content {\n  __isContent: __typename\n  topics {\n    relatedNewsletters {\n      ...helpersMassageToNewsletterItemNewsletter\n      id\n    }\n    id\n  }\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        relatedNewsletters {\n          ...helpersMassageToNewsletterItemNewsletter\n          id\n        }\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n  ... on Article {\n    relatedNewsletters {\n      ...helpersMassageToNewsletterItemNewsletter\n      id\n    }\n  }\n}\n\nfragment contentReadingTimeContent on Content {\n  __isContent: __typename\n  readingTime\n  flag\n}\n\nfragment contentSchemaRenderContent on Content {\n  __isContent: __typename\n  ...blockquoteQuoteContent\n  ...hooksInlinePlusWidgetContent\n  ...imageContent\n  ...inlineWidgetContent\n  ...photoGalleryWidgetContent\n  ...scmpYoutubeContent\n}\n\nfragment contentSectionsContent on Content {\n  __isContent: __typename\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        name\n      }\n      ... on VideoSection {\n        name\n      }\n      ...helpersCheckIfNewsSectionInFirstIndexSection\n      ...entityLink\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n\nfragment contentSeriesShortLabelContent on Content {\n  __isContent: __typename\n  ... on Article {\n    seriesShortLabel\n    ...entityLink\n    seriesContainer {\n      ...entityLink\n      seriesShortLabel\n      id\n    }\n  }\n}\n\nfragment contentShareWidgetContent on Content {\n  __isContent: __typename\n  __typename\n  entityId\n  urlAlias\n  shortUrl\n  socialHeadline\n  headline\n  ... on Video {\n    youtubeId\n  }\n}\n\nfragment contentSponsorTagContent on Content {\n  __isContent: __typename\n  ...helpersUseContentSponsorContent\n}\n\nfragment contentSubHeadlineContent on Content {\n  __isContent: __typename\n  subHeadline {\n    json\n  }\n  summary {\n    json\n  }\n  ...contentSchemaRenderContent\n}\n\nfragment contentSummaryContent on Content {\n  __isContent: __typename\n  __typename\n  summary {\n    text\n  }\n}\n\nfragment contentTopicLinkContent on Content {\n  __isContent: __typename\n  topics {\n    urlAlias\n    ...entityLink\n    ...topicLinkTopic\n    id\n  }\n}\n\nfragment contextsSectionContextProviderSection on Section {\n  ...hooksUseSectionBaseAdvertisingInfoSection\n}\n\nfragment discoveryWidgetPostMagazineQueueQuery on Query {\n  postMagazineLast7Days: queue(filter: {name: \"scmp_trending_section_scmp_trending_section_postmag_last_7_days\"}) {\n    items(first: 6) {\n      edges {\n        node {\n          __typename\n          ... on Article {\n            entityId\n            ...postMagazineDiscoveryItemContent\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n      }\n    }\n    id\n  }\n  postMagazineSponsor: queue(filter: {name: \"discovery_module_discovery_module_71\"}) {\n    items(first: 1) {\n      edges {\n        node {\n          __typename\n          ... on Article {\n            ...postMagazineDiscoveryItemContent\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n      }\n    }\n    id\n  }\n  postMagazineSection: section(filter: {entityId: \"71\"}) {\n    ...entityLink\n    id\n  }\n}\n\nfragment entityFollowButtonBase on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  __typename\n  ... on Section {\n    entityId\n    name\n  }\n  ... on Author {\n    entityId\n    name\n    disableFollow\n  }\n  ... on Topic {\n    entityId\n    name\n    disableFollow\n  }\n}\n\nfragment entityLink on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  __typename\n  entityId\n  entityUuid\n  urlAlias\n  urlRedirect {\n    toUrl\n    id\n  }\n  application {\n    entityId\n    id\n  }\n  ... on Section {\n    fullSectionPath {\n      entityId\n      id\n    }\n    parentSection\n  }\n  ...helpersAppBarVariantBase\n  ...helpersApplicationBase\n  ...helpersCheckIsPlusArticle\n  ...helpersStyleSectionContent\n}\n\nfragment entityLinkHeaderFeaturesArticle on Article {\n  authors {\n    name\n    ...entityLink\n    id\n  }\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        name\n        published\n        ...entityLink\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n\nfragment entityOnelineMenuLiteQueueItemsEdge on QueueItemsEdge {\n  node {\n    __typename\n    ... on Topic {\n      name\n      urlAlias\n    }\n    ... on Section {\n      name\n      urlAlias\n      urlRedirect {\n        toUrl\n        id\n      }\n    }\n    ... on VideoSection {\n      name\n      urlAlias\n      urlRedirect {\n        toUrl\n        id\n      }\n    }\n    ...entityLink\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment entityOnelineMenuQueueItemsEdge on QueueItemsEdge {\n  node {\n    __typename\n    ... on Topic {\n      name\n      urlAlias\n    }\n    ... on Section {\n      name\n      urlAlias\n      urlRedirect {\n        toUrl\n        id\n      }\n    }\n    ...entityLink\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment focusArticleHomeFocusArticleQuery_4COOKT on Query {\n  focus: queue(filter: {name: $focusQueueName}) {\n    settings\n    items(first: 1) {\n      edges {\n        node {\n          __typename\n          ...homeFocusContentItemContent\n          ...helpersGetArticleTitleArticle\n          ...helpersGetPodcastTitlePodcast\n          ...helpersGetVideoTitleVideo\n          ...helpersCheckIsLiveArticle\n          ...helpersGetArticleLogoArticle\n          ... on Content {\n            __isContent: __typename\n            entityId\n            urlAlias\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment followButtonBase on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  ...entityFollowButtonBase\n  entityId\n}\n\nfragment genericArticleSpeechInlineWidgetGenericArticle on Article {\n  entityId\n  ...buttonArticleSpeechInlineWidgetGenericButtonArticle\n  ...hooksShowGenericInlineWidgetByArticleArticle\n  ...toolTipArticleSpeechWidgetToolTipArticle\n  ...utilitiesGetHasArticleSpeechArticle\n}\n\nfragment headerPostMagazineQuery on Query {\n  postMagSection: section(filter: {entityId: \"71\"}) {\n    urlAlias\n    subSections {\n      items {\n        edges {\n          ...entityOnelineMenuQueueItemsEdge\n        }\n      }\n      id\n    }\n    id\n  }\n}\n\nfragment helpersAppBarVariantBase on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  ...helpersCheckIsLiveArticle\n  ...helpersCheckIsPlusPage\n  ...helpersCheckIsPostMagazineArticle\n  ...helpersCheckIsStyleArticle\n  ...helpersSectionContent\n  ...helpersStyleSectionContent\n}\n\nfragment helpersApplicationBase on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  ...helpersCheckIsPlusPage\n}\n\nfragment helpersCheckHasLiveTagArticle on Article {\n  flattenTypeIds\n  liveArticle {\n    status\n    id\n  }\n}\n\nfragment helpersCheckHasSeriesShortLabelContent on Content {\n  __isContent: __typename\n  ... on Article {\n    seriesShortLabel\n    seriesContainer {\n      seriesShortLabel\n      id\n    }\n  }\n}\n\nfragment helpersCheckIfNewsSectionInFirstIndexSection on SectionUnion {\n  __isSectionUnion: __typename\n  ... on Section {\n    name\n  }\n  ... on VideoSection {\n    name\n  }\n}\n\nfragment helpersCheckIsAmpEnabledArticle on Article {\n  entityId\n  types {\n    value {\n      entityId\n      id\n    }\n  }\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        entityId\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n  disableOffPlatformContent\n  sponsorType\n  published\n  ...helpersCheckIsPlusArticle\n}\n\nfragment helpersCheckIsLiveArticle on Article {\n  flattenTypeIds\n  liveArticle {\n    status\n    id\n  }\n}\n\nfragment helpersCheckIsMainTopicContent on Content {\n  __isContent: __typename\n  topics {\n    entityId\n    id\n  }\n}\n\nfragment helpersCheckIsPlusArticle on Content {\n  __isContent: __typename\n  ... on Article {\n    paywallTypes {\n      entityUuid\n      id\n    }\n  }\n}\n\nfragment helpersCheckIsPlusPage on Page {\n  urlAlias\n}\n\nfragment helpersCheckIsPostMagazineArticle on Content {\n  __isContent: __typename\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        entityId\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n\nfragment helpersCheckIsStyleArticle on Content {\n  __isContent: __typename\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        entityId\n      }\n      ... on VideoSection {\n        entityId\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n\nfragment helpersGetArticleLogoArticle on Article {\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        entityId\n        name\n        urlAlias\n        image(filter: {type: TERM_LOGO}) {\n          style(filter: {style: \"100x100\"}) {\n            url\n          }\n        }\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n\nfragment helpersGetArticleTitleArticle on Article {\n  types {\n    value {\n      entityId\n      id\n    }\n  }\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        entityId\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n\nfragment helpersGetArticleTypeArticle on Content {\n  __isContent: __typename\n  ... on Article {\n    types {\n      value {\n        entityId\n        id\n      }\n    }\n  }\n}\n\nfragment helpersGetArticleTypeNameArticle on Article {\n  types {\n    value {\n      entityId\n      id\n    }\n  }\n}\n\nfragment helpersGetContentTypeNameContent on Content {\n  __isContent: __typename\n  __typename\n  ... on Article {\n    ...helpersGetArticleTypeNameArticle\n  }\n}\n\nfragment helpersGetLabelContent on Content {\n  __isContent: __typename\n  __typename\n  ... on Article {\n    types {\n      value {\n        name\n        id\n      }\n    }\n    sectionsV2 {\n      value {\n        __typename\n        ... on Section {\n          name\n        }\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n      }\n    }\n  }\n  ... on Gallery {\n    __typename\n  }\n  ... on Video {\n    __typename\n  }\n}\n\nfragment helpersGetPodcastTitlePodcast on Podcast {\n  __typename\n}\n\nfragment helpersGetVideoTitleVideo on Video {\n  sectionsV2 {\n    value {\n      __typename\n      ... on VideoSection {\n        entityId\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n\nfragment helpersIsArticleVideoAsHeroArticle on Article {\n  multimediaEmbed {\n    json\n  }\n}\n\nfragment helpersMassageToNewsletterItemNewsletter on Newsletter {\n  entityId\n  name\n  alternativeName\n  description {\n    text\n  }\n  summary {\n    text\n  }\n  homepageDescription {\n    text\n  }\n}\n\nfragment helpersRosettaArticleContextArticle on Content {\n  __isContent: __typename\n  topics {\n    name\n    id\n  }\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        name\n      }\n      ... on VideoSection {\n        name\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n\nfragment helpersSanitizeArticleTypeEntityIdsArticle on Article {\n  types {\n    value {\n      entityId\n      id\n    }\n  }\n}\n\nfragment helpersSanitizeAuthorTypesArticle on Article {\n  authors {\n    types\n    id\n  }\n}\n\nfragment helpersSanitizedAuthorEntityIdsArticle on Article {\n  authors {\n    entityId\n    id\n  }\n}\n\nfragment helpersSectionContent on Section {\n  fullSectionPath {\n    entityId\n    id\n  }\n}\n\nfragment helpersStyleSectionContent on Section {\n  fullSectionPath {\n    entityId\n    id\n  }\n}\n\nfragment helpersUseContentSponsorContent on Content {\n  __isContent: __typename\n  topics {\n    entityId\n    sponsor {\n      ...sponsorTagSponsor\n      name\n      type\n      id\n    }\n    id\n  }\n  ... on Article {\n    sponsorType\n  }\n  ...helpersCheckIsMainTopicContent\n}\n\nfragment helpersUseSharingUrl on Content {\n  __isContent: __typename\n  urlAlias\n}\n\nfragment homeFocusContentItemContent on Content {\n  __isContent: __typename\n  ...entityLink\n  entityId\n  ... on Video {\n    duration\n  }\n  ...hooksContentItemProvidersContent_Q7hCx\n}\n\nfragment homePrimaryContentItemContent on Content {\n  __isContent: __typename\n  entityId\n  urlAlias\n  ...entityLink\n  ...helpersCheckIsPlusArticle\n  ...helpersCheckHasLiveTagArticle\n  ...helpersCheckHasSeriesShortLabelContent\n  ...helpersUseContentSponsorContent\n  ...hooksContentItemProvidersContent_3LgACx\n}\n\nfragment homeSecondaryContentItemContent on Content {\n  __isContent: __typename\n  entityId\n  urlAlias\n  ...entityLink\n  ...helpersCheckIsPlusArticle\n  ...helpersCheckHasLiveTagArticle\n  ...helpersCheckHasSeriesShortLabelContent\n  ...helpersUseContentSponsorContent\n  ...hooksContentItemProvidersContent_1uhIyn\n}\n\nfragment hooksArticleSeoArticle on Article {\n  ...helpersCheckIsPostMagazineArticle\n  ...helpersCheckIsStyleArticle\n  ...hooksContentHeadlineTagContent\n  ...helpersCheckIsAmpEnabledArticle\n  entityId\n  headline\n  socialHeadline\n  types {\n    value {\n      entityId\n      id\n    }\n  }\n  authors {\n    entityId\n    id\n  }\n  images {\n    generic_og: style(filter: {style: \"og_image_scmp_generic\"}) {\n      url\n    }\n    styles(filter: {styles: [\"og_postmag\", \"og_image_style\", \"og_image_scmp_analysis\", \"og_image_scmp_explainer\", \"og_image_scmp_editorial\", \"og_image_scmp_fact_check\", \"og_image_scmp_live\", \"og_image_scmp_obituary\", \"og_image_scmp_opinion\", \"og_image_scmp_review\", \"og_image_scmp_series\", \"og_image_scmp_generic\"]}) {\n      url\n      style\n    }\n    type\n  }\n  urlAlias\n}\n\nfragment hooksContentHeadlineTagContent on Content {\n  __isContent: __typename\n  __typename\n  ... on Article {\n    types {\n      value {\n        name\n        entityId\n        description {\n          text\n        }\n        id\n      }\n    }\n    ...helpersCheckIsStyleArticle\n  }\n  flag\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        name\n      }\n      ... on VideoSection {\n        name\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n  ...hooksContentHelperContent\n}\n\nfragment hooksContentHelperContent on Content {\n  __isContent: __typename\n  ...helpersSanitizeArticleTypeEntityIdsArticle\n  ...helpersSanitizeAuthorTypesArticle\n  ...helpersSanitizedAuthorEntityIdsArticle\n  flag\n}\n\nfragment hooksContentInterestArticle on Content {\n  __isContent: __typename\n  __typename\n  entityId\n  urlAlias\n  topics {\n    name\n    id\n  }\n  ... on Article {\n    sentiment\n    types {\n      value {\n        name\n        id\n      }\n    }\n  }\n}\n\nfragment hooksContentItemProvidersContent_14w7Xi on Content {\n  __isContent: __typename\n  ...contentCoverImageContent_2ihLSb\n  ...contentHeadlineContent\n  ...contentSummaryContent\n  ...contentReadingTimeContent\n  ...contentSponsorTagContent\n  ... on Video {\n    __typename\n    ...videoDurationOverlayVideo\n  }\n  ... on Gallery {\n    __typename\n  }\n}\n\nfragment hooksContentItemProvidersContent_1aiv1W on Content {\n  __isContent: __typename\n  ...contentHeadlineContent\n  ...contentSponsorTagContent\n  ... on Video {\n    __typename\n  }\n  ... on Gallery {\n    __typename\n  }\n}\n\nfragment hooksContentItemProvidersContent_1uhIyn on Content {\n  __isContent: __typename\n  ...contentActionBarContent\n  ...contentCoverImageContent_2ihLSb\n  ...contentHeadlineContent\n  ...contentLiveTagContent\n  ...contentSectionsContent\n  ...contentSubHeadlineContent\n  ...contentSummaryContent\n  ...contentTopicLinkContent\n  ...contentSponsorTagContent\n  ...contentSeriesShortLabelContent\n  ... on Video {\n    __typename\n    ...videoDurationOverlayVideo\n  }\n  ... on Gallery {\n    __typename\n  }\n}\n\nfragment hooksContentItemProvidersContent_2RX0zR on Content {\n  __isContent: __typename\n  ...contentActionBarContent\n  ...contentAuthorImageContent\n  ...contentAuthorLinkContent\n  ...contentHeadlineContent\n  ...contentSponsorTagContent\n  ... on Video {\n    __typename\n  }\n  ... on Gallery {\n    __typename\n  }\n}\n\nfragment hooksContentItemProvidersContent_2gnGW2 on Content {\n  __isContent: __typename\n  ...contentActionBarContent\n  ...contentHeadlineContent\n  ...contentLiveTagContent\n  ...contentSectionsContent\n  ...contentSubHeadlineContent\n  ...contentSummaryContent\n  ...contentTopicLinkContent\n  ...contentSponsorTagContent\n  ... on Video {\n    __typename\n    ...videoDurationOverlayVideo\n  }\n  ... on Gallery {\n    __typename\n  }\n}\n\nfragment hooksContentItemProvidersContent_3LgACx on Content {\n  __isContent: __typename\n  ...contentActionBarContent\n  ...contentCoverImageContent_1SslBT\n  ...contentHeadlineContent\n  ...contentLiveTagContent\n  ...contentSectionsContent\n  ...contentSummaryContent\n  ...contentTopicLinkContent\n  ...contentSponsorTagContent\n  ...contentSeriesShortLabelContent\n  ... on Video {\n    __typename\n    ...videoDurationOverlayVideo\n  }\n  ... on Gallery {\n    __typename\n  }\n}\n\nfragment hooksContentItemProvidersContent_3SIuYu on Content {\n  __isContent: __typename\n  ...contentCoverImageContent_2ihLSb\n  ...contentHeadlineContent\n  ...contentSponsorTagContent\n  ... on Video {\n    __typename\n    ...videoDurationOverlayVideo\n  }\n  ... on Gallery {\n    __typename\n  }\n}\n\nfragment hooksContentItemProvidersContent_4hutWY on Content {\n  __isContent: __typename\n  ...contentCoverImageContent_3UtnDL\n  ...contentHeadlineContent\n  ...contentSponsorTagContent\n  ... on Video {\n    __typename\n  }\n  ... on Gallery {\n    __typename\n  }\n}\n\nfragment hooksContentItemProvidersContent_9hDaW on Content {\n  __isContent: __typename\n  ...contentCoverImageContent_3i5ehM\n  ...contentHeadlineContent\n  ...contentTopicLinkContent\n  ...contentSponsorTagContent\n  ... on Video {\n    __typename\n  }\n  ... on Gallery {\n    __typename\n  }\n}\n\nfragment hooksContentItemProvidersContent_Q7hCx on Content {\n  __isContent: __typename\n  ...contentCoverImageContent_2zNOHT\n  ...contentHeadlineContent\n  ...contentSponsorTagContent\n  ... on Video {\n    __typename\n    ...videoDurationOverlayVideo\n  }\n  ... on Gallery {\n    __typename\n  }\n}\n\nfragment hooksContentItemProvidersContent_Y5tau on Content {\n  __isContent: __typename\n  ...contentActionBarContent\n  ...contentCoverImageContent_2g6DLq\n  ...contentHeadlineContent\n  ...contentSponsorTagContent\n  ... on Video {\n    __typename\n  }\n  ... on Gallery {\n    __typename\n  }\n}\n\nfragment hooksContentItemProvidersContent_fODHX on Content {\n  __isContent: __typename\n  ...contentCoverImageContent_1g6fcK\n  ...contentHeadlineContent\n  ...contentTopicLinkContent\n  ...contentSponsorTagContent\n  ... on Video {\n    __typename\n  }\n  ... on Gallery {\n    __typename\n  }\n}\n\nfragment hooksInlinePlusWidgetContent on Content {\n  __isContent: __typename\n  topics {\n    entityId\n    id\n  }\n}\n\nfragment hooksPaywallPromiseContent on Content {\n  __isContent: __typename\n  entityId\n}\n\nfragment hooksPickSubSectionArticle_3ASum4 on Queue {\n  items(first: $first) {\n    edges {\n      node {\n        __typename\n        ... on Content {\n          __isContent: __typename\n          ...postMagazinePrimaryContent\n        }\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment hooksShowGenericInlineWidgetByArticleArticle on Article {\n  ...hooksPaywallPromiseContent\n  entityId\n  flag\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        entityId\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n  types {\n    value {\n      entityId\n      id\n    }\n  }\n  topics {\n    entityId\n    id\n  }\n}\n\nfragment hooksSubSectionWidgetAndAdsQuery_1XnROE on Query {\n  parentSection: section(filter: {entityUuid: $parentSectionUuid}) {\n    entityId\n    id\n  }\n  ...commentQueueQuery_2qpcKW @include(if: $includeComment)\n  ...discoveryWidgetPostMagazineQueueQuery @include(if: $includePostMagazine)\n  ...hundredTopTablesDiscoveryWidgetQuery\n  ...multimediaQuery_4rBIay @include(if: $includeMultimedia)\n  ...chinaFutureTechDiscoveryWidgetQuery @include(if: $includeChinaFutureTechDiscovery)\n  ...openQuestionsSeriesDiscoveryWidgetQuery_2uEaAo\n  subSection: section(filter: {entityId: $entityId}) {\n    entityId\n    advertZone(version: 2)\n    id\n  }\n  ...focusArticleHomeFocusArticleQuery_4COOKT @include(if: $includeFocusArticle)\n}\n\nfragment hooksTrackCurrentItemBase_4oKxOH on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  __typename\n  ...atomsCurrentArticleAtomBase_3GTCBR\n  ...atomsCurrentShareContentAtomBase\n  ...atomsCurrentStyleCardCarouselWidgetSectionsAtomBase\n  ...atomsCurrentTakeoverAdSectionsAtomBase\n}\n\nfragment hooksTrackPageViewArticle on Content {\n  __isContent: __typename\n  entityId\n  publishedDate\n  headline\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        name\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n  urlAlias\n  authors {\n    name\n    id\n  }\n  entityUuid\n  ... on Article {\n    types {\n      value {\n        name\n        id\n      }\n    }\n  }\n}\n\nfragment hooksUseCurrentArticleIdsArticle on Content {\n  __isContent: __typename\n  entityId\n  entityUuid\n}\n\nfragment hooksUseCurrentArticlePrebidConfigArticle on Article {\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        entityId\n        name\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n  topics {\n    name\n    id\n  }\n}\n\nfragment hooksUseDeepLinkTagsBase on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  __typename\n  urlAlias\n  entityId\n}\n\nfragment hooksUseDynamicMetaTags on DynamicMetaTags {\n  __isDynamicMetaTags: __typename\n  metatags {\n    key\n    value\n  }\n}\n\nfragment hooksUsePageTargetingArticle on Article {\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        name\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n  firstTopic {\n    name\n    id\n  }\n}\n\nfragment hooksUseSectionBaseAdvertisingInfoSection on Section {\n  advertZone(version: 2)\n  entityId\n}\n\nfragment hundredTopTablesContent on Content {\n  __isContent: __typename\n  ...entityLink\n  ...hooksContentItemProvidersContent_Y5tau\n}\n\nfragment hundredTopTablesDiscoveryWidgetQuery on Query {\n  hundredTopTablesLast7Days: queue(filter: {name: \"scmp_trending_section_scmp_trending_section_100_top_tables_last_7_days\"}) {\n    items(first: 5) {\n      edges {\n        node {\n          __typename\n          ... on Article {\n            entityId\n            ...hundredTopTablesContent\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n      }\n    }\n    id\n  }\n  hundredTopTablesSponsor: queue(filter: {name: \"discovery_module_discovery_module_517759\"}) {\n    items(first: 1) {\n      edges {\n        node {\n          __typename\n          ... on Article {\n            ...hundredTopTablesContent\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n      }\n    }\n    id\n  }\n  hundredTopTablesSection: section(filter: {entityId: \"517759\"}) {\n    ...entityLink\n    id\n  }\n}\n\nfragment imageContent on Content {\n  __isContent: __typename\n  headline\n  ...checkersCheckContentContainsStarlingImageContent\n}\n\nfragment inlineWidgetContent on Content {\n  __isContent: __typename\n  ...contentNewsletterWidgetContent\n}\n\nfragment latestDiscoveryWidgetQueue on Queue {\n  items(first: 6) {\n    edges {\n      node {\n        __typename\n        ... on Article {\n          entityId\n          ...homeSecondaryContentItemContent\n        }\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment latestDiscoveryWidgetSection on Section {\n  urlAlias\n  name\n  entityId\n  parentSection\n}\n\nfragment magazinesStyleCardContentItemContent on Content {\n  __isContent: __typename\n  topics {\n    entityId\n    ...topicLinkTopic\n    id\n  }\n  ...entityLink\n  ...helpersCheckIsMainTopicContent\n  ...hooksContentItemProvidersContent_4hutWY\n}\n\nfragment multimediaContentItemContent on Content {\n  __isContent: __typename\n  entityId\n  urlAlias\n  ... on Gallery {\n    images {\n      __typename\n    }\n  }\n  ...entityLink\n  ...helpersGetLabelContent\n  ...hooksContentItemProvidersContent_3SIuYu\n}\n\nfragment multimediaPodcastContentItemContent on Content {\n  __isContent: __typename\n  entityId\n  urlAlias\n  ... on Article {\n    images {\n      style(filter: {style: \"100x100\"}) {\n        url\n      }\n    }\n  }\n  ... on Podcast {\n    podcastSections {\n      images {\n        style(filter: {style: \"100x100\"}) {\n          url\n        }\n      }\n      name\n      id\n    }\n  }\n  ...entityLink\n  ...hooksContentItemProvidersContent_1aiv1W\n}\n\nfragment multimediaQuery_4rBIay on Query {\n  multimedia: queue(filter: {name: $multimediaQueueName}) {\n    items(first: 4) {\n      edges {\n        node {\n          __typename\n          ... on Article {\n            types {\n              value {\n                name\n                id\n              }\n            }\n          }\n          ... on Content {\n            __isContent: __typename\n            entityId\n            ...multimediaContentItemContent\n            ...multimediaPodcastContentItemContent\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment onboardingNewsletterSubscriptionArticle on Article {\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        entityId\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n\nfragment oneSectionTopWidgetQueue_1gV4SW on QueueItemsEdge {\n  node {\n    __typename\n    ... on Content {\n      __isContent: __typename\n      ...homeSecondaryContentItemContent\n      ...sectionTopLeadPrimaryContentItemContent_1gV4SW\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment openQuestionsSeriesDiscoveryWidgetQuery_2uEaAo on Query {\n  openQuestionSeriesTopic: topic(filter: {entityId: \"518656\"}) {\n    name\n    urlAlias\n    contents(exclude: {paywallTypeIds: $scmpPlusPaywallTypeIds}, first: 6, orderBy: {field: PUBLISHED_DATE, direction: DESC}) {\n      edges {\n        node {\n          __typename\n          ... on Article {\n            entityId\n            ...homeSecondaryContentItemContent\n          }\n          id\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment photoGalleryDialogContent on Content {\n  __isContent: __typename\n  __typename\n  ...contentShareWidgetContent\n}\n\nfragment photoGalleryWidgetContent on Content {\n  __isContent: __typename\n  ...photoGalleryDialogContent\n}\n\nfragment popupArticle20ShareMenuContent on Content {\n  __isContent: __typename\n  ...articleShareWidgetArticle\n}\n\nfragment postMagazineDiscoveryItemContent on Content {\n  __isContent: __typename\n  entityId\n  urlAlias\n  ...articleCommentArticle\n  ...entityLink\n  ...helpersCheckHasLiveTagArticle\n  ...helpersUseContentSponsorContent\n  ...hooksContentItemProvidersContent_14w7Xi\n}\n\nfragment postMagazineNewsletter on Query {\n  newsletter(filter: {entityId: \"322743\"}) {\n    description {\n      text\n    }\n    summary {\n      text\n    }\n    id\n  }\n}\n\nfragment postMagazinePrimaryContent on Content {\n  __isContent: __typename\n  entityId\n  urlAlias\n  ...entityLink\n  ...helpersUseContentSponsorContent\n  ...hooksContentItemProvidersContent_9hDaW\n}\n\nfragment postMagazineSecondaryContent on Content {\n  __isContent: __typename\n  entityId\n  urlAlias\n  ...entityLink\n  ...hooksContentItemProvidersContent_fODHX\n}\n\nfragment scmpYoutubeContent on Content {\n  __isContent: __typename\n  entityId\n  urlAlias\n  publishedDate\n}\n\nfragment sectionDescriptionSection on Section {\n  description {\n    text\n    json\n  }\n}\n\nfragment sectionNewsletterWidgetQuery_49mQWb on Query {\n  section(filter: {entityId: $entityId}) {\n    entityId\n    id\n  }\n}\n\nfragment sectionSeoSection on Section {\n  name\n  description {\n    text\n  }\n  entityId\n  entityUuid\n  image(filter: {type: OG}) {\n    url\n  }\n  parentSection\n  urlAlias\n  ...hooksUseDeepLinkTagsBase\n  ...hooksUseDynamicMetaTags\n}\n\nfragment sectionTermLogoSection on Section {\n  name\n  sectionLogo: image(filter: {type: TERM_LOGO}) {\n    style(filter: {style: \"100x100\"}) {\n      url\n    }\n  }\n}\n\nfragment sectionTopLeadPrimaryContentItemContent_1gV4SW on Content {\n  __isContent: __typename\n  entityId\n  urlAlias\n  topics {\n    ...followButtonBase\n    id\n  }\n  ...entityLink\n  ...contentCoverImageContent_2eYJyj\n  ...helpersCheckIsPlusArticle\n  ...helpersCheckHasLiveTagArticle\n  ...helpersUseContentSponsorContent\n  ...hooksContentItemProvidersContent_2gnGW2\n}\n\nfragment shareArticle20Content on Content {\n  __isContent: __typename\n  ...popupArticle20ShareMenuContent\n}\n\nfragment shareHeaderFeaturesContent on Content {\n  __isContent: __typename\n  ...shareArticle20Content\n}\n\nfragment sponsorTagSponsor on Sponsor {\n  name\n  type\n  images {\n    url\n  }\n}\n\nfragment subSectionIndexArticleList_2HEEH6 on Queue {\n  items(first: $first, after: $after) {\n    edges {\n      ...oneSectionTopWidgetQueue_1gV4SW\n      ...topStoriesBlockQueueItemsEdge\n      cursor\n      node {\n        __typename\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n      }\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  id\n}\n\nfragment subSectionPostMagazineIndexArticleList_2HEEH6 on Queue {\n  items(first: $first, after: $after) {\n    edges {\n      node {\n        __typename\n        ...postMagazinePrimaryContent\n        ...postMagazineSecondaryContent\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  id\n}\n\nfragment subSectionPostMagazineProfileQuery_46g90v on Query {\n  section(filter: {entityId: $entityId}) {\n    name\n    description {\n      text\n    }\n    id\n  }\n  topicQueue: queue(filter: {name: $postMagazineSubSectionTopicQueueName}) {\n    items(first: 5) {\n      edges {\n        node {\n          __typename\n          ... on Topic {\n            entityId\n            ...topicLinkTopic\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment subSectionPostMagazineQuery_414Qbb on Query {\n  articles: queue(filter: {name: $articlesQueueName}) {\n    ...subSectionPostMagazineIndexArticleList_2HEEH6\n    id\n  }\n  sponsorQueue: queue(filter: {name: $sponsorQueueName}) {\n    ...hooksPickSubSectionArticle_3ASum4\n    id\n  }\n  section(filter: {entityId: $entityId}) {\n    entityId\n    advertZone(version: 2)\n    id\n  }\n  ...headerPostMagazineQuery\n  ...subSectionPostMagazineProfileQuery_46g90v\n  ...postMagazineNewsletter\n}\n\nfragment subSectionQuery_4vrZbj on Query {\n  subSection: section(filter: {entityId: $entityId}) {\n    name\n    entityId\n    parentSection\n    ...sectionTermLogoSection\n    ...sectionDescriptionSection\n    advertZone(version: 2)\n    id\n  }\n  parentSection: section(filter: {entityUuid: $parentSectionUuid}) @include(if: $hasParentSection) {\n    name\n    entityId\n    ...entityLink\n    id\n  }\n  relatedTopics: queue(filter: {name: $relatedTopicsQueueName}) {\n    items {\n      edges {\n        ...entityOnelineMenuLiteQueueItemsEdge\n      }\n    }\n    id\n  }\n  articles: queue(filter: {name: $articlesQueueName}) {\n    ...subSectionIndexArticleList_2HEEH6\n    id\n  }\n  ...hooksSubSectionWidgetAndAdsQuery_1XnROE\n  ...sectionNewsletterWidgetQuery_49mQWb\n}\n\nfragment subSectionStyleArticleListQuery_3iJxr on Query {\n  sectionArticles: queue(filter: {name: $articlesQueueName}) {\n    items(first: $first, after: $after) {\n      edges {\n        node {\n          __typename\n          ... on Article {\n            ...magazinesStyleCardContentItemContent\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n        cursor\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n    id\n  }\n}\n\nfragment subSectionStyleContentQuery_1HvVap on Query {\n  ...subSectionStyleHeadQuery_h9NtA\n  ...subSectionStyleArticleListQuery_3iJxr\n}\n\nfragment subSectionStyleHeadQuery_h9NtA on Query {\n  relatedSections: queue(filter: {name: $relatedSectionsQueueName}) {\n    items(first: 10) {\n      edges {\n        node {\n          __typename\n          ... on Section {\n            name\n            entityId\n          }\n          ...entityLink\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n      }\n    }\n    id\n  }\n  section(filter: {entityId: $entityId}) {\n    name\n    parentSection\n    images(filter: {type: {values: [\"logo\"]}}) {\n      url\n    }\n    fullSectionPath {\n      name\n      entityUuid\n      images(filter: {type: {values: [\"logo\"]}}) {\n        url\n      }\n      ...entityLink\n      id\n    }\n    ...entityLink\n    id\n  }\n}\n\nfragment toolTipArticleSpeechWidgetToolTipArticle on Article {\n  entityId\n}\n\nfragment topStoriesBlockQueueItemsEdge on QueueItemsEdge {\n  node {\n    __typename\n    ... on Content {\n      __isContent: __typename\n      ...topStoriesItemContent\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment topStoriesItemContent on Content {\n  __isContent: __typename\n  ...homePrimaryContentItemContent\n  ...homeSecondaryContentItemContent\n  ...helpersUseContentSponsorContent\n}\n\nfragment topicLinkTopic on Topic {\n  ...entityLink\n  name\n  shortName\n}\n\nfragment utilitiesGetHasArticleSpeechArticle on Article {\n  articleSpeeches {\n    url\n  }\n}\n\nfragment videoDurationOverlayVideo on Video {\n  duration\n  sectionsV2 {\n    value {\n      __typename\n      ... on VideoSection {\n        entityId\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "a55208c532581aeb9e84e0a88a5ef5af";

export default node;
